/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		28: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"widgets","1":"facebook","3":"live_chat","4":"delivery_estimates","5":"goods_local_supply","6":"product_reviews","7":"merchant_v2","10":"tip_widget","11":"g_map"}[chunkId]||chunkId) + "-" + {"0":"4f74496cc8","1":"e4400b0e70","3":"24462f2883","4":"05e878e25b","5":"22651a46c2","6":"2e67fecb28","7":"33b0807e0a","10":"6824a97258","11":"55971553b2"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 413);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = __webpack_require__(36);
Hogan.Template = __webpack_require__(37).Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = _;

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {// Generated by CoffeeScript 2.0.0-beta7
void function () {
  var MagicEventBus;
  MagicEventBus = function () {
    function MagicEventBus() {
      this.handlers = {};
      this.statuses = {};
    }
    MagicEventBus.prototype.board = function (eventName, callback, errorHandler) {
      var position;
      if (null != this.handlers[eventName])
        this.handlers[eventName];
      else
        this.handlers[eventName] = [];
      position = this._pushHandler(eventName, callback, errorHandler);
      return function (this$) {
        return function (zIndex) {
          return this$.handlers[eventName][position].zIndex = zIndex;
        };
      }(this);
    };
    MagicEventBus.prototype.go = function (eventName, eventElement) {
      var handler, sortedHandlers;
      if (!(null != this.handlers[eventName]))
        return false;
      this.statuses[eventName] = 'going';
      sortedHandlers = this.handlers[eventName].slice().sort(function (a, b) {
        return (a.zIndex || 0) - (b.zIndex || 0);
      });
      for (var i$ = 0, length$ = sortedHandlers.length; i$ < length$; ++i$) {
        handler = sortedHandlers[i$];
        if (this.statuses[eventName] === 'stopTheBus')
          break;
        this._callback(eventName, handler, eventElement);
      }
      return this.statuses[eventName] = 'stopped';
    };
    MagicEventBus.prototype._callback = function (eventName, param$, eventElement) {
      var cache$, callback, errorHandler, results;
      {
        cache$ = param$;
        callback = cache$.callback;
        errorHandler = cache$.errorHandler;
      }
      results = function () {
        var error;
        try {
          return callback(eventElement);
        } catch (e$) {
          error = e$;
          if ('undefined' !== typeof TrackingHub && null != TrackingHub)
            TrackingHub.add('MagicEventBus ' + eventName + ' Error', { error: error });
          if ('function' === typeof errorHandler)
            return errorHandler();
        }
      }.call(this);
      if (null != results ? results.stopTheBus : void 0)
        return this.statuses[eventName] = 'stopTheBus';
    };
    MagicEventBus.prototype._pushHandler = function (eventName, callback, errorHandler) {
      this.handlers[eventName].push({
        callback: callback,
        errorHandler: errorHandler
      });
      return this.handlers[eventName].length - 1;
    };
    return MagicEventBus;
  }();
  if ('undefined' !== typeof window && null != window)
    window.MagicEventBus = MagicEventBus;
  if ('undefined' !== typeof module && null != module)
    module.exports = MagicEventBus;
}.call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

var WishlistButton;

WishlistButton = window.WishlistButton != null ? window.WishlistButton : window.WishlistButton = {};

WishlistButton = function() {
  var $wishlistButton, $wishlistButtonTextAdd, $wishlistButtonTextRemove, addItemToWishlist, csrfToken, dealId, getRemoveItemUrl, getSelectedUUID, init, listenToOptionSelection, multiOptionBreakoutClicked, onAddItemSuccess, removeItemFromWishlist, selectedOptionUUID, setSelectedItem, toggleWishlistButtonStyle, updateWishlistedNotifier, wishlistButtonClicked, wishlistPayload;
  $wishlistButton = wishlistPayload = dealId = csrfToken = selectedOptionUUID = null;
  $wishlistButtonTextAdd = $wishlistButtonTextRemove = null;
  init = function(arg, done) {
    var $multiOptionBreakout, csrf, wishlist;
    csrf = arg.csrf, wishlist = arg.wishlist;
    $wishlistButton = $(".add-to-wishlist-btn");
    $wishlistButtonTextAdd = $(".add-to-wishlist-btn-text-add");
    $wishlistButtonTextRemove = $(".add-to-wishlist-btn-text-remove");
    $multiOptionBreakout = $(".multi-option-breakout input,.multi-option-overlay-list input");
    wishlistPayload = wishlist;
    dealId = wishlist.dealUUID;
    setSelectedItem(wishlistPayload);
    csrfToken = csrf;
    listenToOptionSelection();
    $(function() {
      $wishlistButton.on("click", function(e) {
        return wishlistButtonClicked(e);
      });
      $multiOptionBreakout.on("click", multiOptionBreakoutClicked);
      return done();
    });
    return this;
  };
  setSelectedItem = function() {
    if (wishlistPayload.selectedOptionUUID) {
      return selectedOptionUUID = wishlistPayload.selectedOptionUUID;
    } else {
      return selectedOptionUUID = null;
    }
  };
  multiOptionBreakoutClicked = function(e) {
    var target;
    target = $(e.target);
    selectedOptionUUID = target.data("uuid");
    return updateWishlistedNotifier(selectedOptionUUID);
  };
  updateWishlistedNotifier = function(optionUUID) {
    var currentItem;
    $wishlistButton.removeClass("wishlisted");
    $wishlistButtonTextAdd.removeClass("hidden");
    $wishlistButtonTextRemove.addClass("hidden");
    currentItem = null;
    currentItem = _.find(wishlistPayload.items, function(item) {
      return item.optionId === optionUUID;
    });
    if (currentItem) {
      $wishlistButton.addClass("wishlisted");
      $wishlistButtonTextAdd.addClass("hidden");
      $wishlistButtonTextRemove.removeClass("hidden");
      wishlistPayload.removeItemUrl = currentItem.removeItemUrl;
    }
    return currentItem;
  };
  listenToOptionSelection = function() {
    return window.DealEventPipe.on("priceUpdate", function(priceData) {
      var $tooltip;
      $tooltip = $('#select-option-tooltip');
      GIG.Tooltip.close($tooltip);
      selectedOptionUUID = priceData.variationsSelected ? priceData.uuid : null;
      return updateWishlistedNotifier(selectedOptionUUID);
    });
  };
  toggleWishlistButtonStyle = function() {
    $wishlistButton.toggleClass("wishlisted");
    $wishlistButtonTextAdd.toggleClass("hidden");
    return $wishlistButtonTextRemove.toggleClass("hidden");
  };
  onAddItemSuccess = function(data) {
    var addedItem;
    if (!selectedOptionUUID) {
      selectedOptionUUID = null;
    }
    addedItem = {
      dealId: dealId,
      itemId: data.itemId,
      listId: data.listId,
      optionId: selectedOptionUUID,
      removeItemUrl: "/deals/wishlists_proxy/remove/" + data.listId + "/" + data.itemId
    };
    wishlistPayload.items.push(addedItem);
    wishlistPayload.removeItemUrl = addedItem.removeItemUrl;
    return toggleWishlistButtonStyle();
  };
  addItemToWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.addItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        dealId: dealId,
        optionId: selectedOptionUUID ? selectedOptionUUID : void 0,
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $(".wishlist-add-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, status, xhr) {
        return onAddItemSuccess(data);
      },
      complete: function() {
        return $wishlistButton.prop('disabled', false);
      }
    });
  };
  removeItemFromWishlist = function() {
    $wishlistButton.prop('disabled', true);
    return $.ajax({
      url: wishlistPayload.removeItemUrl,
      dataType: "json",
      type: "POST",
      data: {
        _csrf: csrfToken
      },
      error: function(jqxhr, textStatus, error) {
        return $(".wishlist-remove-error").fadeIn().delay(3000).fadeOut();
      },
      success: function(data, textStatus, error) {
        toggleWishlistButtonStyle();
        return wishlistPayload.items = _.reject(wishlistPayload.items, function(item) {
          return item.optionId === selectedOptionUUID;
        });
      },
      complete: function() {
        $wishlistButton.prop('disabled', false);
        return selectedOptionUUID = null;
      }
    });
  };
  wishlistButtonClicked = function(e) {
    if ($wishlistButton.hasClass("wishlisted")) {
      return removeItemFromWishlist();
    } else {
      return addItemToWishlist();
    }
  };
  getSelectedUUID = function() {
    return selectedOptionUUID;
  };
  getRemoveItemUrl = function() {
    return wishlistPayload.removeItemUrl;
  };
  return {
    init: init,
    onAddItemSuccess: onAddItemSuccess,
    getSelectedUUID: getSelectedUUID,
    getRemoveItemUrl: getRemoveItemUrl
  };
};

window.WishlistButton = WishlistButton();

module.exports = WishlistButton;


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable no-undef */



window.Affirm = {};

Affirm.updateAffirmPrice = function (newAffirmPrice) {
  var el = document.querySelector('.affirm-as-low-as');
  if (el === null) {
    return;
  }
  el.setAttribute('data-amount', newAffirmPrice);
  affirm.ui.refresh();
};

Affirm.displayBannerInCalendar = function () {
  var el = document.querySelector('.affirm-section');
  return el ? el.style.display = 'block' : undefined;
};

Affirm.removeBanner = function () {
  var el = document.querySelector('.affirm-section');
  return el ? el.remove() : undefined;
};

module.exports = Affirm;

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

if (window.Gift == null) {
  window.Gift = {};
}

Gift.init = function(payload, done) {
  var ref;
  Gift.cookieDomain = payload != null ? (ref = payload.giftButton) != null ? ref.cookieDomain : void 0 : void 0;
  return $(function() {
    Gift.bindGiftButton();
    return done();
  });
};

Gift.bindGiftButton = function() {
  var $gift_button;
  $gift_button = $('.gift-button');
  if ($gift_button.length > 0) {
    return $gift_button.on('click', function(e) {
      e.preventDefault();
      Gift.createCookie();
      BuyButton.view.giftButtonClicked = true;
      return BuyButton.eventBus.go('buy_button_clicked');
    });
  }
};

Gift.createCookie = function() {
  Cookie.set('modalForGiftOnLoad', 'true', 60, Gift.cookieDomain);
  return Gift.cookieCreated = true;
};

Gift.removeCookie = function() {
  Cookie.unset('modalForGiftOnLoad', Gift.cookieDomain);
  return Gift.cookieCreated = false;
};

module.exports = Gift;


/***/ }),

/***/ 218:
/***/ (function(module, exports) {

var loadJs;

loadJs = function(urls, cb, onLoad) {
  var load;
  if (urls == null) {
    urls = [];
  }
  if (cb == null) {
    cb = _.noop;
  }
  if (onLoad == null) {
    onLoad = false;
  }
  if (!_.isArray(urls)) {
    urls = [urls];
  }
  load = function() {
    return $.when.apply(window, _.map(urls, function(url) {
      return $.ajax({
        url: url,
        dataType: 'script',
        cache: true
      });
    })).done(cb);
  };
  if (onLoad) {
    return $(window).load(load);
  }
  return load();
};

module.exports = {
  getLegalDisclaimerText: function(env) {
    var privacyStatement, termsOfUse;
    termsOfUse = I18n.t('js.modules.applepay.terms_of_use');
    privacyStatement = I18n.t('js.modules.applepay.privacy_statement');
    return I18n.t("js.modules.applepay." + env + ".legal_disclaimer", {
      termsOfUse: '<a href="/terms">' + termsOfUse + '</a>',
      privacyStatement: '<a href="/privacy">' + privacyStatement + '</a>'
    });
  },
  lazyLoadJs: function(urls, fn, onLoad) {
    return loadJs(urls, fn, onLoad);
  }
};


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* globals window, OptimizeSuite, BOOMR */
/*eslint-disable no-console*/



var underscore = __webpack_require__(1);

/*
 requiring this polyfill because phantomjs 1.9.8 does not have the bind function,
  which is needed by webpack
 This should be removed when our CI is on phantomjs 2 and all our browsers have this function
*/
__webpack_require__(220)();

window.asyncInitializer = function (modulePromises, timeOut, callback) {
  var safeInit = function safeInit(obj, cb) {
    try {
      obj.init(window.payload, cb);
    } catch (error) {
      OptimizeSuite.TrackingHub.add('DealPage-AsyncFrontEndInit-Error', {
        error: error
      });
      if (window.location.hostname === 'localhost') {
        console.error(error);
      }
      cb();
    }
  };

  var loadedModules = 0;
  var initModules = 0;
  var initStart = new Date();
  modulePromises.forEach(function (modulePromise) {
    modulePromise.then(function (module) {
      loadedModules += 1;
      safeInit(module, function () {
        initModules += 1;
        if (initModules === modulePromises.length && typeof BOOMR !== 'undefined' && typeof BOOMR.addVar === 'function') {
          BOOMR.addVar('deal_page_async_modules_initialized', new Date() - initStart);
        }
      });
      if (loadedModules === modulePromises.length) {
        window._ = underscore;
        callback(initStart);
      }
    }).catch(function (error) {
      OptimizeSuite.TrackingHub.add('DealPage-AsyncFrontModulePromise-Error', { error: error });
    });
  });

  setTimeout(function () {
    if (loadedModules !== modulePromises.length) {
      OptimizeSuite.TrackingHub.add('DealPage-AsyncFrontModules-Timeout', {
        numberInFlight: loadedModules
      });
      if (window.location.hostname === 'localhost') {
        console.error('Frontend Async Module Initialization timed out');
      }
      callback(initStart);
    }
  }, timeOut);
};

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

/* eslint-disable */

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

module.exports = function () {
  if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
      if (typeof this !== 'function') {
        // closest thing possible to the ECMAScript 5
        // internal IsCallable function
        throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
      }

      var aArgs = Array.prototype.slice.call(arguments, 1),
          fToBind = this,
          fNOP = function fNOP() {},
          fBound = function fBound() {
        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
      };

      if (this.prototype) {
        // Function.prototype doesn't have a prototype property
        fNOP.prototype = this.prototype;
      }
      fBound.prototype = new fNOP();

      return fBound;
    };
  }
};

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

module.exports = function() {
  var body_size, config, deal_data, ref, t_api, t_done, t_page, t_page_presenter, t_resp, variants;
  config = typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Utils) != null ? ref.getConfigFromDom() : void 0 : void 0;
  if (!(config != null ? config.pageLoadData : void 0)) {
    return;
  }
  if (!(typeof BOOMR !== "undefined" && BOOMR !== null ? BOOMR.getVar : void 0)) {
    return;
  }
  t_resp = BOOMR.getVar('t_resp');
  t_page = BOOMR.getVar('t_page');
  t_done = BOOMR.getVar('t_done');
  variants = config.pageLoadData.experiments;
  deal_data = config.pageLoadData.dealData;
  t_page_presenter = config.pageLoadData.pagePresenterTime;
  t_api = config.pageLoadData.apiTime;
  body_size = BOOMR.getVar('body_size');
  return OptimizeSuite.TrackingHub.add('deal_page_experiment_performance', {
    deal_data: deal_data,
    t_page: t_page,
    t_done: t_done,
    t_resp: t_resp,
    t_page_presenter: t_page_presenter,
    t_api: t_api,
    body_size: body_size,
    variants: variants
  });
};


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventPipe = function () {
  function EventPipe() {
    _classCallCheck(this, EventPipe);

    this.eventsHash = {};
  }

  _createClass(EventPipe, [{
    key: 'on',
    value: function on(eventName, cb, context) {
      if (!this.eventsHash[eventName]) {
        this.eventsHash[eventName] = [];
      }
      var boundCb = context ? cb.bind(context) : cb;
      this.eventsHash[eventName].push(boundCb);
    }
  }, {
    key: 'off',
    value: function off(eventName) {
      this.eventsHash[eventName] = undefined;
    }
  }, {
    key: 'trigger',
    value: function trigger(eventName) {
      var _arguments = arguments;

      Array.isArray(this.eventsHash[eventName]) ? this.eventsHash[eventName].forEach(function (fn) {
        return fn.apply(undefined, _toConsumableArray([].slice.call(_arguments, 1)));
      }) : undefined;
    }
  }, {
    key: 'once',
    value: function once(eventName, cb, context) {
      var _arguments2 = arguments;

      var boundOff = this.off.bind(this);
      var onceCb = function onceCb() {
        cb.apply(undefined, _arguments2);
        boundOff(eventName);
      };
      this.on(eventName, onceCb, context);
    }
  }]);

  return EventPipe;
}();

window.DealEventPipe = new EventPipe();
module.exports = EventPipe;

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, isUrgencyPricing) {
  switch (false) {
    case !(timeLeft.days > 1):
      if (isUrgencyPricing) {
        return ".countdown_time_many_days";
      } else {
        return ".countdown_days";
      }
      break;
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.CountdownTimer == null) {
    window.CountdownTimer = {};
  }
  if (CountdownTimer.Helpers == null) {
    CountdownTimer.Helpers = {};
  }
  CountdownTimer.Helpers.timeRemaining = timeRemaining;
  CountdownTimer.Helpers.millisRemaining = millisRemaining;
  CountdownTimer.Helpers.countdownTimeKey = countdownTimeKey;
  CountdownTimer.Helpers.countdownTimestamp = countdownTimestamp;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp
  };
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.Model = (function() {
  function Model(arg) {
    var endAt;
    endAt = arg.endAt;
    this.endAt = endAt;
  }

  Model.prototype.timeLeft = function() {
    var millisLeft;
    millisLeft = CountdownTimer.Helpers.millisRemaining(this.endAt);
    return CountdownTimer.Helpers.timeRemaining(millisLeft);
  };

  return Model;

})();


/***/ }),

/***/ 243:
/***/ (function(module, exports) {

var DEFAULT_EL, DEFAULT_TRANSLATION_SCOPE;

DEFAULT_EL = '.limited-time > .counter li.countdown-timer';

DEFAULT_TRANSLATION_SCOPE = 'js.modules.groupon-deal-timer';

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

CountdownTimer.View = (function() {
  function View(options) {
    this.options = options;
    ({
      UPDATE_FREQUENCY_MS: 1000
    });
    this.model = this.options.model;
    this.i18n = this.options.i18n;
    this.el = this.options.el || DEFAULT_EL;
    this.translationScope = this.options.translationScope || DEFAULT_TRANSLATION_SCOPE;
  }

  View.prototype.render = function() {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    this.$el = $(this.el);
    return this.interval = setInterval(((function(_this) {
      return function() {
        return _this.updateCountdown();
      };
    })(this)), this.UPDATE_FREQUENCY_MS);
  };

  View.prototype.updateCountdown = function() {
    var countdownTime, timeLeft;
    timeLeft = this.model.timeLeft();
    countdownTime = this.t("" + this.translationScope + (CountdownTimer.Helpers.countdownTimeKey(timeLeft, true)), {
      days: timeLeft.days,
      timerIcon: '<span class="icon-now"></span>',
      timestamp: "<span class='countdown-timestamp'>" + (CountdownTimer.Helpers.countdownTimestamp(timeLeft)) + "</span>"
    });
    return this.$el.html(countdownTime);
  };

  View.prototype.t = function() {
    return this.i18n.t.apply(this.i18n, arguments);
  };

  return View;

})();


/***/ }),

/***/ 244:
/***/ (function(module, exports) {

var base;

if (window.CountdownTimer == null) {
  window.CountdownTimer = {};
}

if ((base = window.CountdownTimer).current == null) {
  base.current = {};
}

CountdownTimer.init = function(arg, done) {
  var endAt, ref, timerData, timerModel, timerView;
  timerData = arg.timerData;
  if (done == null) {
    done = function() {};
  }
  endAt = timerData != null ? (ref = timerData.expiringSoon) != null ? ref.endAt : void 0 : void 0;
  if (!endAt) {
    return done();
  }
  timerModel = new CountdownTimer.Model({
    endAt: endAt
  });
  window.CountdownTimer.current.timerModel = timerModel;
  window.CountdownTimer.current.timerView = new CountdownTimer.View({
    model: timerModel,
    i18n: I18n.scoped(),
    el: timerData != null ? timerData.el : void 0,
    translationScope: timerData != null ? timerData.translationScope : void 0
  });
  timerView = window.CountdownTimer.current.timerView;
  return $(function() {
    timerView.render();
    return done();
  });
};


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StickyHandler = function () {
  function StickyHandler(_ref) {
    var _this = this;

    var $element = _ref.$element,
        _ref$$wrapper = _ref.$wrapper,
        $wrapper = _ref$$wrapper === undefined ? $element : _ref$$wrapper,
        _ref$bottom = _ref.bottom,
        bottom = _ref$bottom === undefined ? false : _ref$bottom,
        _ref$staySticky = _ref.staySticky,
        staySticky = _ref$staySticky === undefined ? false : _ref$staySticky,
        _ref$onStateChange = _ref.onStateChange,
        onStateChange = _ref$onStateChange === undefined ? function () {} : _ref$onStateChange;

    _classCallCheck(this, StickyHandler);

    this.$element = $element;
    this.$wrapper = $wrapper;
    this.$prevElement = this.$wrapper.prev();

    if (!this.$element.length) {
      return;
    }

    this.bottom = bottom;
    this.staySticky = staySticky;
    this.onStateChange = onStateChange;

    this.stickyClasses = 'sticky sticky-' + (this.bottom ? 'bottom' : 'top');
    this.fixed = this.$element.hasClass('sticky');

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: this.bottom ? '0px' : (this.$element.css('padding-top') || '0px') + ' 0px 0px 0px',
      threshold: this.bottom ? 1 : [0, 1]
    });
    this.observedElement = this.bottom ? this.$element[0] : this.$prevElement[0];
    this.observer.observe(this.observedElement);

    if (this.bottom) {
      this._checkForAutoScroll();
    }

    // listener to hide sticky handler after coming back from modal
    window.addEventListener('hashchange', function () {
      if (_this.fixed && !_this.staySticky) {
        _this.change(false);
      }
    }.bind(this), false);
  }

  _createClass(StickyHandler, [{
    key: '_checkForAutoScroll',
    value: function _checkForAutoScroll() {
      var _this2 = this;

      /*
        Intersection Observer does not work when user reloads the page after scrolling
        Need to do one time check to see if browser is auto-scrolling
      */
      var checkIfAutoScrolled = function () {
        if (_this2.$element.offset().top < window.pageYOffset) {
          _this2.change(true);
        }
        window.removeEventListener('scroll', checkIfAutoScrolled);
      }.bind(this);
      window.addEventListener('scroll', checkIfAutoScrolled, false);
    }
  }, {
    key: 'onIntersect',
    value: function onIntersect(entries) {
      var _this3 = this;

      entries.forEach(function (entry) {
        var intersectionRatio = entry.intersectionRatio,
            rootBounds = entry.rootBounds,
            boundingClientRect = entry.boundingClientRect;

        if (!_this3.bottom && rootBounds.bottom < boundingClientRect.top) {
          _this3.change(false);
        } else if (intersectionRatio === 0) {
          _this3.change(!_this3.bottom);
        } else if (intersectionRatio === 1 && _this3.bottom) {
          _this3.change(true);
        } else if (intersectionRatio > 0 && !_this3.bottom && _this3.fixed) {
          _this3.change(false);
        }
      });
    }
  }, {
    key: 'change',
    value: function change(shouldBeFixed) {
      if (!this.fixed && shouldBeFixed) {
        this.updateCss(shouldBeFixed);
        this.onStateChange();
        if (this.staySticky) {
          this.observer.unobserve(this.observedElement);
        }
      } else if (this.fixed && !shouldBeFixed) {
        this.updateCss(shouldBeFixed);
        this.onStateChange();
      }
    }
  }, {
    key: 'updateCss',
    value: function updateCss(shouldBeFixed) {
      this.fixed = shouldBeFixed;
      if (shouldBeFixed) {
        this.$element.addClass(this.stickyClasses);
      } else {
        this.$element.removeClass(this.stickyClasses);
      }
    }
  }]);

  return StickyHandler;
}();

module.exports = StickyHandler;

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

var PURCHASE_CLUSTER_PADDING, StickyHandler, StickyPurchaseCluster;

StickyHandler = __webpack_require__(426);

PURCHASE_CLUSTER_PADDING = 12;

StickyPurchaseCluster = window.StickyPurchaseCluster != null ? window.StickyPurchaseCluster : window.StickyPurchaseCluster = {};

StickyPurchaseCluster.init = function(payload, done) {
  return $(function() {
    var container, element;
    element = $("#purchase-cluster > div");
    container = $('.deal-container');
    new StickyHandler(element, container, PURCHASE_CLUSTER_PADDING);
    return done();
  });
};

module.exports = StickyPurchaseCluster;


/***/ }),

/***/ 252:
/***/ (function(module, exports) {

var safeInit;

if (window.Tracking == null) {
  window.Tracking = {};
}

safeInit = function(obj, payload, cb) {
  var err;
  try {
    return obj.init(payload, cb);
  } catch (error) {
    err = error;
    OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Error", {
      error: err
    });
    if (window.location.hostname === 'localhost' && (console.error != null)) {
      console.error(err);
    }
    return cb();
  }
};

Tracking.Initializer = function(timeoutInMs) {
  var finished, inFlight;
  if (timeoutInMs == null) {
    timeoutInMs = 30 * 1000;
  }
  inFlight = 0;
  this._hasRun = false;
  finished = false;
  return {
    run: function(modules, payload, cb) {
      var i, len, module;
      for (i = 0, len = modules.length; i < len; i++) {
        module = modules[i];
        inFlight++;
        safeInit(module, payload, (function(_this) {
          return function() {
            inFlight--;
            if (inFlight === 0 && _this._hasRun && !finished) {
              finished = true;
              return cb();
            }
          };
        })(this));
      }
      this._hasRun = true;
      if (inFlight === 0 && !finished) {
        finished = true;
        cb();
      }
      return setTimeout((function() {
        if (!finished) {
          OptimizeSuite.TrackingHub.add("DealPage-FrontEndInit-Timeout", {
            numberInFlight: inFlight
          });
          finished = true;
          if (window.location.hostname === 'localhost' && (console.error != null)) {
            console.error("Frontend Module Initialization timed out");
          }
          return cb();
        }
      }), timeoutInMs);
    }
  };
};

module.exports = Tracking.Initializer;


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DealCarousel = __webpack_require__(254);

var Carousel = {};
window.Carousel = Carousel;

Carousel.init = function (payload, done) {
  Carousel.instance = new DealCarousel(payload);
  return done();
};

module.exports = Carousel;

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// cant use some es6 methods without full polyfill

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);

var ThumbnailTray = __webpack_require__(255);
var MediaContainer = __webpack_require__(256);

var DEFAULT_RATIO = 700 / 420;

var DealCarousel = function () {
  function DealCarousel(payload) {
    var _this = this;

    _classCallCheck(this, DealCarousel);

    this.data = payload.carousel;
    this.$el = $('#carousel');
    this.isLoaded = false;

    if (this.data.showControls) {
      this.$controlForward = this.$el.find('.carousel-controls .forward');
      this.$controlBack = this.$el.find('.carousel-controls .back');
    }

    if (this.data.hasMultipleImages) {
      this.thumbnailTray = new ThumbnailTray(this.data, this.$el);
    }

    var postSwapActions = {};
    if (this.data.hasTraits) {
      _.extend(postSwapActions, {
        triggerCarouselUpdate: function triggerCarouselUpdate() {
          return _this.triggerCarouselUpdate();
        }
      });
    }
    if (this.data.hasMultipleImages) {
      _.extend(postSwapActions, {
        updateThumbnail: function updateThumbnail(nextMediaObj) {
          return _this.thumbnailTray.jumpToThumbnail(nextMediaObj.getId());
        }
      });
    }

    var onLoadAction = 'Carousel.instance.onLoad()';
    this.mediaContainer = new MediaContainer(this.data, this.$el, onLoadAction, postSwapActions);

    if (this.data.hasTraits) {
      window.DealEventPipe.on('traitsUpdate', function (data) {
        return _this.handleTraitsUpdate(data);
      });
    }

    this.fixHeight();
    return this;
  }

  _createClass(DealCarousel, [{
    key: 'handleTraitsUpdate',
    value: function handleTraitsUpdate(data) {
      if (this.isLoaded) {
        this.mediaContainer.handleMediaSwap('getIndexFromTraits', data, {
          triggerCarouselUpdate: undefined
        });
      } else if (this.data.hasTraits) {
        this.traitsTriggeredDuringPreload = data;
      }
    }
  }, {
    key: 'fixHeight',
    value: function fixHeight() {
      var width = this.$el.width();
      if (this.data.hasMultipleImages && this.thumbnailTray.isVertical) {
        width = width - this.thumbnailTray.$thumbnailWrapper.outerWidth(true);
      }

      var height = width / (this.data.ratio || DEFAULT_RATIO);
      this.mediaContainer.fixHeight(height, width);
      if (this.data.hasMultipleImages) {
        this.thumbnailTray.fixHeight(height);
      }
    }
  }, {
    key: 'onLoad',
    value: function onLoad() {
      var _this2 = this;

      this.isLoaded = true;
      this.fixHeight();
      this.mediaContainer.onLoad();

      if (this.traitsTriggeredDuringPreload) {
        this.handleTraitsUpdate(this.traitsTriggeredDuringPreload);
        this.traitsTriggeredDuringPreload = undefined;
      } else {
        if (this.data.imageZoom) {
          this.mediaContainer.setUpZoom(this.mediaContainer.currentMedia);
        }
        this.mediaContainer.preloadMedia();
      }

      if (this.data.showControls) {
        this.$controlForward.click(function (e) {
          return _this2.mediaContainer.handleMediaSwap('incrementIndex', { e: e });
        });
        this.$controlBack.click(function (e) {
          return _this2.mediaContainer.handleMediaSwap('decrementIndex', { e: e });
        });
      }

      if (this.data.hasMultipleImages) {
        this.thumbnailTray.onLoad(this.mediaContainer.getActiveId());

        this.thumbnailTray.$thumbnails.on(this.thumbnailTray.getChangeEventType(), function (e) {
          return _this2.mediaContainer.handleMediaSwap('getIndexByDataId', { e: e, dataId: e.currentTarget.dataset.id }, {
            updateThumbnail: function updateThumbnail(nextMediaObj, data) {
              return _this2.thumbnailTray.adjustThumbnail(nextMediaObj.getId(), data);
            }
          });
        });
      }

      $(window).resize(function () {
        return _this2.fixHeight();
      });
    }
  }, {
    key: 'triggerCarouselUpdate',
    value: function triggerCarouselUpdate() {
      window.DealEventPipe.trigger('carouselUpdate', this.mediaContainer.getTraitsByIndex());
    }
  }]);

  return DealCarousel;
}();

module.exports = DealCarousel;

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThumbnailTray = function () {
  function ThumbnailTray(data, $el) {
    _classCallCheck(this, ThumbnailTray);

    this.isVertical = data.vertical;
    this.sizeProp = this.isVertical ? "height" : "width";
    this.positionProp = this.isVertical ? "top" : "left";

    this.carouselSize = $el[this.sizeProp]();
    this.$thumbControlForward = $el.find('.thumbnails-button.forward');
    this.$thumbControlBack = $el.find('.thumbnails-button.back');
    this.$thumbnailWrapper = $el.find('.thumbnail-wrapper');
    this.$thumbnails = this.$thumbnailWrapper.find('li');
    this.$thumbnailTray = this.$thumbnailWrapper.find("#thumbnail-tray");
  }

  _createClass(ThumbnailTray, [{
    key: "fixHeight",
    value: function fixHeight(height) {
      if (this.isVertical) this.$thumbnailWrapper.css({ height: height });
    }
  }, {
    key: "onLoad",
    value: function onLoad(newImageId) {
      var _this = this;

      this.updateSelectedThumbnail(newImageId);
      var $thumbnailImgs = this.$thumbnails.find('img');

      this.thumbnailDimension = this.isVertical ? this.$thumbnailTray.find("li").first().outerHeight(true) : this.$thumbnailTray.find("li").first().outerWidth(true);

      var thumbnailSize = $thumbnailImgs.length * this.thumbnailDimension;
      this.$thumbnailTray.css(this.sizeProp, thumbnailSize + "px");

      if (this.carouselSize < thumbnailSize) {
        this.$thumbnailTray.css("margin", "0px");
        this.$thumbnailWrapper.find('.thumbnails-controls').show();
        var cssProps = {};
        cssProps["padding-" + this.resolveDimensionName(false)] = '20px';
        cssProps["padding-" + this.resolveDimensionName(true)] = '20px';
        this.$thumbnailWrapper.css(cssProps);
        this.calculateThumbnailPages();
      } else {
        this.$thumbnailWrapper.find('.thumbnails-controls').remove();
      }

      this.$thumbControlForward.click(function () {
        return _this.pageThumbnailsForward();
      });
      this.$thumbControlBack.click(function () {
        return _this.pageThumbnailsBack();
      });

      $thumbnailImgs.lazyload({ skip_invisible: false });

      $(window).resize(function () {
        return _this.calculateThumbnailPages();
      });
    }
  }, {
    key: "getChangeEventType",
    value: function getChangeEventType() {
      return this.isVertical ? 'mouseenter' : 'click';
    }
  }, {
    key: "calculateThumbnailPages",
    value: function calculateThumbnailPages() {
      var thumbnailSize = parseInt(this.$thumbnailTray.css(this.sizeProp));
      var carouselSize = this.isVertical ? this.$thumbnailWrapper.height() : this.$thumbnailWrapper.width();
      carouselSize -= carouselSize % this.thumbnailDimension;
      this.thumbnailTrayMultiples = carouselSize;
      this.thumbnailTraySize = this.isVertical ? this.$thumbnailTray.innerHeight() : this.$thumbnailTray.innerWidth();
      this.thumbnailFullPages = Math.floor(thumbnailSize / carouselSize);
      this.thumbnailHasPartial = this.thumbnailFullPages != thumbnailSize / carouselSize;
    }
  }, {
    key: "getCurrentThumbnailBounds",
    value: function getCurrentThumbnailBounds() {
      var lowerbound = Math.abs(parseInt(this.$thumbnailTray.css(this.positionProp)));
      var higherbound = lowerbound + (this.isVertical ? this.$thumbnailWrapper.height() : this.$thumbnailWrapper.width());
      return { lowerbound: lowerbound, higherbound: higherbound };
    }
  }, {
    key: "getThumbnailPosition",
    value: function getThumbnailPosition(thumbnail) {
      var position = thumbnail.position();
      if (this.isVertical) {
        position.left = position.top;
        position.right = position.left + this.thumbnailDimension - 10;
      } else {
        position.right = position.left + this.thumbnailDimension;
      }
      return position;
    }
  }, {
    key: "updateSelectedThumbnail",
    value: function updateSelectedThumbnail(newImageId) {
      this.$thumbnails.removeClass('selected');
      var newThumbnail = this.$thumbnailWrapper.find("li[data-id='" + newImageId + "']");
      newThumbnail.addClass('selected');
    }
  }, {
    key: "adjustThumbnail",
    value: function adjustThumbnail(newImageId) {
      this.updateSelectedThumbnail(newImageId);

      var $newThumbnail = this.$thumbnailWrapper.find("li[data-id='" + newImageId + "']");

      if (this.thumbnailHasPartial) {
        var _getCurrentThumbnailB = this.getCurrentThumbnailBounds(),
            lowerbound = _getCurrentThumbnailB.lowerbound,
            higherbound = _getCurrentThumbnailB.higherbound;

        var position = this.getThumbnailPosition($newThumbnail);

        var newPosition = void 0;

        if (position.left < higherbound && position.right > higherbound) {
          newPosition = this.$thumbnailWrapper[this.sizeProp]() - ($newThumbnail.position()[this.positionProp] + this.thumbnailDimension) + 10;
        } else if (position.left < lowerbound && position.right > lowerbound) {
          newPosition = -$newThumbnail.position()[this.positionProp];
        }

        if (newPosition !== undefined) {
          this.$thumbnailTray.css(this.positionProp, newPosition + "px");
        }
      }
    }
  }, {
    key: "jumpToThumbnail",
    value: function jumpToThumbnail(newImageId) {
      this.updateSelectedThumbnail(newImageId);
      var newThumbnail = this.$thumbnailWrapper.find("li[data-id=\"" + newImageId + "\"]");

      var _getCurrentThumbnailB2 = this.getCurrentThumbnailBounds(),
          lowerbound = _getCurrentThumbnailB2.lowerbound,
          higherbound = _getCurrentThumbnailB2.higherbound;

      var position = this.getThumbnailPosition(newThumbnail);

      if (position.left < lowerbound || position.right > higherbound) {
        var thumbnailEdge = this.$thumbnailWrapper[this.sizeProp]() - this.$thumbnailTray[this.sizeProp]() + 10;
        var newPosition = Math.max(-newThumbnail.position()[this.positionProp], thumbnailEdge);

        this.$thumbnailTray.css(this.positionProp, newPosition + "px");
      }
    }
  }, {
    key: "pageThumbnailsForward",
    value: function pageThumbnailsForward() {
      var position = void 0,
          lowerbound = void 0,
          upperbound = void 0,
          currentPosition = void 0;
      currentPosition = parseInt(this.$thumbnailTray.css(this.positionProp));
      lowerbound = 0;
      upperbound = this.$thumbnailWrapper[this.sizeProp]() - this.$thumbnailTray[this.sizeProp]() + 10;
      if (currentPosition === upperbound) {
        position = lowerbound;
      } else {
        position = Math.max(upperbound, currentPosition - this.thumbnailTrayMultiples);
      }
      this.$thumbnailTray.css(this.positionProp, position + "px");
    }
  }, {
    key: "pageThumbnailsBack",
    value: function pageThumbnailsBack() {
      var position = void 0,
          lowerbound = void 0,
          upperbound = void 0,
          currentPosition = void 0;
      currentPosition = parseInt(this.$thumbnailTray.css(this.positionProp));
      lowerbound = 0;
      upperbound = this.$thumbnailWrapper[this.sizeProp]() - this.$thumbnailTray[this.sizeProp]() + 10;
      if (currentPosition === lowerbound) {
        position = upperbound;
      } else {
        position = Math.min(lowerbound, currentPosition + this.thumbnailTrayMultiples);
      }
      this.$thumbnailTray.css(this.positionProp, position + "px");
    }
  }, {
    key: "resolveDimensionName",
    value: function resolveDimensionName(direction) {
      if (direction) {
        if (this.isVertical) return "bottom";
        return "right";
      }
      if (this.isVertical) return "top";
      return "left";
    }
  }]);

  return ThumbnailTray;
}();

module.exports = ThumbnailTray;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env browser, jquery */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(1);
var Media = __webpack_require__(257);

var MediaContainer = function () {
  function MediaContainer(data, $el, onLoadAction, postSwapActions) {
    var _this = this;

    _classCallCheck(this, MediaContainer);

    this.data = data;
    this.index = 0;
    this.$mediaWrapper = $el.find('.media-container');
    this.$featuredImg = this.$mediaWrapper.find('img.current-media');
    this.$featuredImg.lazyload();
    this.$featuredImg.attr('onload', onLoadAction);
    this.$waitingImages = this.$mediaWrapper.find('.waiting-image');

    this.mediaArray = [];
    this.mediaCount = data.media.length;
    for (var i = 0; i < this.mediaCount; i += 1) {
      this.mediaArray.push(new Media(data.media[i], this.$mediaWrapper));
    }
    this.currentMedia = this.mediaArray[this.index];

    var basePostSwapActions = {
      preload: this.preloadMedia
    };
    if (this.data.imageZoom) {
      _.extend(basePostSwapActions, {
        setUpZoom: function setUpZoom(nextMediaObj) {
          return _this.setUpZoom(nextMediaObj);
        }
      });
    }
    this.basePostSwapActions = _.extend({}, basePostSwapActions, postSwapActions);
    this.$zoomMessage = $el.find('.image-zoom-message');
    this.$badging = $el.find('.featured-badge');

    this.fetchVideoScripts(data.videoScriptUrls, $el.find('.video-container, .thumbnail.video'));

    /*
      fallback urls use the same image url for thumbnails and main image;
      Safari won't trigger the onload event for <img>
        when new src is the same as the current, loaded source.
    */
    if (data.media[0].fallbackUrls) {
      // use setTimeout so that onload event will happen after DealCarousel returns
      setTimeout(function () {
        return _this.$featuredImg.trigger('onload');
      }, 0);
    }
  }

  _createClass(MediaContainer, [{
    key: 'fixHeight',
    value: function fixHeight(height, width) {
      this.$mediaWrapper.css({ width: width, height: height });
      this.$mediaWrapper.find('.video-container .video-player').css('height', height);
      this.$mediaWrapper.css('padding-top', 0);
    }
  }, {
    key: 'onLoad',
    value: function onLoad() {
      if (this.$mediaWrapper.hasClass('loaded')) {
        return;
      }
      this.$waitingImages.each(function (index, element) {
        $(element).attr('src', $(element).attr('data-thumb'));
      });

      this.$mediaWrapper.addClass('loaded');
      this.$featuredImg.css({
        filter: 'blur(0px)',
        '-webkit-filter': 'blur(0px)'
      });
      this.$featuredImg.attr('data-loaded', 'true');
    }
  }, {
    key: 'getActiveId',
    value: function getActiveId() {
      return this.currentMedia.getId();
    }
  }, {
    key: 'preloadMedia',
    value: function preloadMedia() {
      this.loadMediaAt(this.index - 1);
      this.loadMediaAt(this.index + 1);
    }
  }, {
    key: 'loadMediaAt',
    value: function loadMediaAt(index) {
      var adjustedIndex = void 0;
      if (index < 0) {
        adjustedIndex = this.mediaCount + index;
      } else if (index >= this.mediaCount) {
        adjustedIndex = 0;
      } else {
        adjustedIndex = index;
      }

      return this.mediaArray[adjustedIndex].load();
    }
  }, {
    key: 'getIndexFromTraits',
    value: function getIndexFromTraits(_ref) {
      var selectedTraits = _ref.selectedTraits;

      if (!this.data.hasTraits) {
        return this.index;
      }
      for (var i = 0; i < this.mediaCount; i += 1) {
        if (!this.mediaArray[i].isVideo) {
          var imageTraits = this.mediaArray[i].data.traits;
          if (!imageTraits || imageTraits.length === 0) continue;

          var traitsMatch = true;
          for (var traitName in selectedTraits) {
            var traitValue = selectedTraits[traitName];
            if (!imageTraits[traitName] || !_.contains(imageTraits[traitName], traitValue)) {
              traitsMatch = false;
              break;
            }
          }
          if (traitsMatch) {
            return i;
          }
        }
      }
      return 0;
    }
  }, {
    key: 'getIndexByDataId',
    value: function getIndexByDataId(_ref2) {
      var dataId = _ref2.dataId;

      return _.findIndex(this.mediaArray, function (media) {
        return media.getId() === dataId;
      });
    }
  }, {
    key: 'getMediaByDataId',
    value: function getMediaByDataId(dataId) {
      return _.find(this.mediaArray, function (media) {
        return media.getId() === dataId;
      });
    }
  }, {
    key: 'incrementIndex',
    value: function incrementIndex() {
      return this.index + 1 === this.mediaCount ? 0 : this.index + 1;
    }
  }, {
    key: 'decrementIndex',
    value: function decrementIndex() {
      return this.index - 1 === -1 ? this.mediaCount - 1 : this.index - 1;
    }
  }, {
    key: 'getTraitsByIndex',
    value: function getTraitsByIndex() {
      return this.mediaArray[this.index].data.traits;
    }
  }, {
    key: 'fetchVideoScripts',
    value: function fetchVideoScripts(videoScriptUrls, $videoEls) {
      if (videoScriptUrls) {
        if (!window.YT && videoScriptUrls.youtubeScriptUrl) {
          $.ajax({
            url: videoScriptUrls.youtubeScriptUrl,
            dataType: 'script',
            fail: function fail() {
              $videoEls !== undefined ? $videoEls.remove() : undefined;
            }
          });
        }
      }
    }
  }, {
    key: 'swapMedia',
    value: function swapMedia(newMediaObj) {
      this.currentMedia.hide();
      newMediaObj.show();
      if (newMediaObj.data.isVideo) {
        this.$badging.hide();
      } else {
        this.$badging.show();
      }
      this.currentMedia = newMediaObj;
    }
  }, {
    key: 'setUpZoom',
    value: function setUpZoom(newMediaObj) {
      if (newMediaObj.setUpZoom()) {
        this.$zoomMessage.removeClass('hide-zoom');
      } else {
        this.$zoomMessage.addClass('hide-zoom');
      }
    }
  }, {
    key: 'handleMediaSwap',
    value: function handleMediaSwap(indexFinder) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var postSwapActions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var newIndex = this[indexFinder](data);
      if (newIndex === this.index || newIndex === undefined || newIndex === -1) return;

      var nextMediaObj = this.loadMediaAt(newIndex);
      // bail out of swap if loadMediaAt fails
      if (!nextMediaObj) return;

      this.index = newIndex;
      this.swapMedia(nextMediaObj);

      var actionsHash = _.extend({}, this.basePostSwapActions, postSwapActions);
      var actionNames = Object.keys(actionsHash);

      for (var i = 0; i < actionNames.length; i += 1) {
        var action = actionsHash[actionNames[i]];
        if (action !== undefined) {
          action.call(this, nextMediaObj, data);
        }
      }
    }
  }]);

  return MediaContainer;
}();

module.exports = MediaContainer;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Media = function () {
  function Media(data, $wrapperEl) {
    _classCallCheck(this, Media);

    this.data = data;
    this.$el = $wrapperEl.find('[data-id="' + data.id + '"]');
    this.$wrapperEl = $wrapperEl;
  }

  _createClass(Media, [{
    key: 'getId',
    value: function getId() {
      return this.data.id;
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$el.removeClass('current-media').css('opacity', 0);
      if (this.data.isVideo) {
        var playerId = this.$el.attr('id');
        var id = this.data.id;
        var height = this.$el.height();
        this.$el.replaceWith('<div id="' + playerId + '" class=\'video-player\' data-id="' + id + '" style="height: ' + height + 'px"></div>');
        this.$el = $('#' + this.data.playerId);
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.$el.addClass('current-media').css('display', 'block').css('opacity', 1);
      if (this.data.isVideo) {
        if (this.data.provider === "YOUTUBE") {
          this.videoPlayer = new YT.Player(this.data.playerId, {
            height: this.$wrapperEl.height(),
            width: this.$wrapperEl.width(),
            videoId: this.data.url,
            playerVars: {
              'rel': 0,
              'showinfo': 0
            },
            events: {
              onReady: function onReady(e) {
                e.target.playVideo();
              }
            }
          });
          this.$el = $('#' + this.data.playerId);
        }
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var _this = this;

      if (this.$el.attr("data-loaded") === "true") {
        //The image has already been loaded
        return this;
      }
      if (!this.$el || !this.$el[0]) {
        return undefined;
      }

      this.$el[0].onload = function () {
        _this.$el.css({
          "filter": "blur(0px)",
          "-webkit-filter": "blur(0px)"
        });
        _this.$el.attr("data-loaded", "true");
      };
      this.$el.attr("src", this.$el.attr("data-original"));
      return this;
    }

    /*
    ZOOM FUNCTIONS
    */

  }, {
    key: 'setUpZoom',
    value: function setUpZoom() {
      var _this2 = this;

      this.zoomScale = 1;
      this.inZoom = false;
      if (!this.$el.attr("data-zoom")) {
        this.$el.css("cursor", "");
        return false;
      }

      this.$el.off('mouseenter').off('mousemove').off('mouseleave').on('mouseenter', function (e) {
        return _this2.startZoom(e);
      }).on('mousemove', function (e) {
        return _this2.continueZoom(e);
      }).on('mouseleave', function (e) {
        return _this2.finishZoom(e);
      });
      return true;
    }
  }, {
    key: 'startZoom',
    value: function startZoom(event) {
      var _this3 = this;

      var originalImageWidth = this.$el[0].naturalWidth;
      this.inZoom = true;
      this.$el[0].onload = function () {
        _this3.zoomScale = _this3.$el[0].naturalWidth / originalImageWidth;
        _this3.performZoomOnImage(_this3.zoomScale, event.offsetX, event.offsetY);
        _this3.$el.attr("data-zoom-loaded", "true");
      };
      this.$el.attr("src", this.$el.attr("data-zoom"));
    }
  }, {
    key: 'continueZoom',
    value: function continueZoom(event) {
      if (!this.inZoom) {
        this.startZoom(event);
      } else {
        if ($(event.target).hasClass("carousel-button")) {
          this.performZoomOnImage(1);
        } else {
          this.$el.css("cursor", "zoom-in");
          this.performZoomOnImage(this.zoomScale, event.offsetX, event.offsetY);
        }
      }
    }
  }, {
    key: 'finishZoom',
    value: function finishZoom(event) {
      this.$el.css("cursor", "");
      this.$el.attr("src", this.$el.attr("data-original"));
      this.$el[0].onload = undefined;
      this.performZoomOnImage(1);
      this.inZoom = false;
    }
  }, {
    key: 'performZoomOnImage',
    value: function performZoomOnImage(scale, x, y) {
      if (x && y) {
        this.$el.css({
          "transform": 'scale(' + scale + ')',
          "transform-origin": x + 'px ' + y + 'px'
        });
      } else {
        this.$el.css({
          "transform": 'scale(' + scale + ')'
        });
      }
    }
  }]);

  return Media;
}();

module.exports = Media;

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

var ChannelTabs;

ChannelTabs = window.ChannelTabs != null ? window.ChannelTabs : window.ChannelTabs = {};

ChannelTabs.init = function(arg, done) {
  var categoriesBaseUrl;
  categoriesBaseUrl = arg.categoriesBaseUrl;
  return $(function() {
    $(".primary-nav").find("a[href='" + categoriesBaseUrl + "']").parent().addClass('active');
    return done();
  });
};

module.exports = ChannelTabs;


/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

var DealController, Discount;

DealController = window.DealController != null ? window.DealController : window.DealController = {};

Discount = __webpack_require__(260);

DealController.init = function(payload, done) {
  return $(function() {
    new Discount.View;
    return done();
  });
};

module.exports = DealController;


/***/ }),

/***/ 260:
/***/ (function(module, exports) {

if (window.Discount == null) {
  window.Discount = {};
}

Discount.View = Backbone.View.extend({
  el: "#discount-data, .discount-data",
  initialize: function() {
    return window.DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        return _this.updateTiles(priceData);
      };
    })(this));
  },
  updateTiles: function(arg) {
    var hideOriginalPriceAndDiscount, percent, savings, value;
    value = arg.value, percent = arg.percent, savings = arg.savings, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    this.$("#discount-value, .discount-value").html(value);
    this.$("#discount-percent, .discount-percent").html(percent);
    this.$("#discount-you-save, .discount-you-save").html(savings);
    if (hideOriginalPriceAndDiscount) {
      return this.$el.parents(".deal-discount").hide();
    } else {
      return this.$el.parents(".deal-discount").show();
    }
  }
});

module.exports = Discount;


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

var ExternalLinks, isBlackListedLink, isLinkToEmptyUrl, isLinkToExternalUrl, isLinkToJs, isLinkToPdf, isMailToLink, isWhiteListedLink;

ExternalLinks = window.ExternalLinks != null ? window.ExternalLinks : window.ExternalLinks = {};

isMailToLink = function(obj) {
  return obj.href.match(/^mailto\:/);
};

isLinkToPdf = function(obj) {
  return /.pdf$/.test(obj.href);
};

isLinkToJs = function(obj) {
  return obj.href.match(/^javascript\:/);
};

isLinkToEmptyUrl = function(obj) {
  return obj.href.match(/^$/);
};

isLinkToExternalUrl = function(obj) {
  return obj.hostname.indexOf(location.hostname.replace('www.', '')) === -1;
};

isWhiteListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

isBlackListedLink = function(obj) {
  var $obj, i, len, selector, selectors;
  selectors = ['.fine-print a.discussion-links.comments', '.diy-gift-card-msg a', '#buy-link', '#options a', '.external-buy'];
  $obj = $(obj);
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    if ($obj.is(selector)) {
      return true;
    }
  }
  return false;
};

$.expr[":"].external = function(obj, index, meta, stack) {
  return (isLinkToExternalUrl(obj) || isLinkToPdf(obj) || isWhiteListedLink(obj)) && !(isMailToLink(obj) || isLinkToJs(obj) || isLinkToEmptyUrl(obj) || isBlackListedLink(obj));
};

ExternalLinks.init = function(payload, done) {
  return $(function() {
    $("a:external").click(function(e) {
      e.preventDefault();
      return window.open($(this).attr('href'), "_blank");
    });
    return done();
  });
};

module.exports = ExternalLinks;


/***/ }),

/***/ 262:
/***/ (function(module, exports) {

if (window.ExternalDeal == null) {
  window.ExternalDeal = {};
}

ExternalDeal.init = function(arg, done) {
  var externalDeal;
  externalDeal = arg.externalDeal;
  if (!externalDeal) {
    return done();
  }
  return $(function() {
    var $externalBuyButton;
    $externalBuyButton = $('.external-buy');
    $externalBuyButton.click(function(e) {
      e.preventDefault();
      window.open($(this).attr('href'));
      return setTimeout(GIG.Modal.close, 3000);
    });
    return done();
  });
};

module.exports = ExternalDeal;


/***/ }),

/***/ 263:
/***/ (function(module, exports) {

if (window.FacebookPromNight == null) {
  window.FacebookPromNight = {};
}

FacebookPromNight.init = function(payload, done) {
  return $(function() {
    $(".share-links .icon-facebook").on({
      click: function(e) {
        e.preventDefault();
        return window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($(this).attr('href')), '_blank', 'width=626,height=436');
      }
    });
    return done();
  });
};

module.exports = FacebookPromNight;


/***/ }),

/***/ 264:
/***/ (function(module, exports) {

var DealLazyLoader;

DealLazyLoader = window.DealLazyLoader = {
  sleepyLoadImages: function() {
    return $('.sleepy-load').lazyload({
      skip_invisible: false
    });
  },
  init: function(payload, done) {
    $(document.body).on('modal-open', function(e, data) {
      return $('#' + data.id).find('.lazy-load').lazyload();
    });
    $(window).load(function() {
      Groupon.Utils.lazyLoadImages({
        skip_invisible: false
      });
      return DealLazyLoader.sleepyLoadImages();
    });
    return done();
  }
};

module.exports = DealLazyLoader;


/***/ }),

/***/ 265:
/***/ (function(module, exports) {

var DealTrackContentLoaded, track;

DealTrackContentLoaded = window.DealTrackContentLoaded = function(startTimestamp) {
  var dealContentLoaded;
  dealContentLoaded = +new Date();
  return track(startTimestamp, dealContentLoaded);
};

track = function(startTimestamp, endTimestamp) {
  if ((typeof BOOMR !== 'undefined') && (typeof BOOMR.addVar === 'function')) {
    return BOOMR.addVar('t_deal_content_loaded', endTimestamp - startTimestamp);
  }
};

module.exports = DealTrackContentLoaded;


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

var VariationsWidget, _scrollToBuyButton;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Collections.Option = __webpack_require__(267);

VariationsWidget.Views.OptionCollection = __webpack_require__(269);

VariationsWidget.Views.Error = __webpack_require__(271);

VariationsWidget.Controller = __webpack_require__(272);

_scrollToBuyButton = function() {
  var top;
  if ($('#purchase-cluster .buy.fixed').length || $('.header-row-sticked').length || $('.header-row-sticky').length) {
    top = $('.main').position().top - 100;
    return $('body,html').animate({
      scrollTop: top
    }, 500);
  }
};

VariationsWidget.init = function(arg, done) {
  var stickyHeader, variations;
  variations = arg.variations, stickyHeader = arg.stickyHeader;
  if (variations == null) {
    return done();
  }
  this.options = variations.options, this.traits = variations.traits, this.uuid = variations.uuid, this.dealOptionUuid = variations.dealOptionUuid, this.preSelectTraits = variations.preSelectTraits, this.printSoldOut = variations.printSoldOut, this.printOptionPrice = variations.printOptionPrice, this.clearTraitsOnCarouselSelection = variations.clearTraitsOnCarouselSelection, this.isGetaways = variations.isGetaways;
  this.collections = VariationsWidget.Collections.Option.create(this.traits);
  BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
    return function() {
      if (BuyButton.view.variationsSelected) {
        return;
      }
      _this.controller.showErrorMessages();
      if (stickyHeader) {
        _scrollToBuyButton();
      }
      BuyButton.view.enableBuyButton();
      return {
        stopTheBus: true
      };
    };
  })(this));
  return $((function(_this) {
    return function() {
      var ref;
      _this.views = VariationsWidget.Views.OptionCollection.create(_this.collections);
      _this.error = new VariationsWidget.Views.Error({
        el: '#variation-error'
      });
      _this.controller = new VariationsWidget.Controller();
      if ((ref = _this.options) != null ? ref[0].hideOriginalPriceAndDiscount : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html("");
      }
      window.DealEventPipe.on('carouselUpdate', function(data) {
        return _this.controller.selectTraitsFromPotentialValues(data);
      });
      return done();
    };
  })(this));
};

module.exports = VariationsWidget;


/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

var VariationsWidget, base;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if ((base = VariationsWidget.Collections).Option == null) {
  base.Option = {};
}

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = __webpack_require__(268);

VariationsWidget.Collections.Option = Backbone.Collection.extend({
  model: VariationsWidget.Models.Option,
  chosen: function(value) {
    return this.find(function(trait) {
      return trait.get('traitValue') === value;
    });
  },
  selected: function() {
    return this.find(function(trait) {
      return trait.get('selected');
    });
  },
  setSelected: function(id) {
    this.selected().set('selected', false);
    return this.get(id).set('selected', true);
  }
});

VariationsWidget.Collections.Option.create = function(traits) {
  var data, i, len, option, results, trait;
  results = [];
  for (i = 0, len = traits.length; i < len; i++) {
    trait = traits[i];
    data = (function() {
      var j, len1, ref, results1;
      ref = trait.data;
      results1 = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        option = ref[j];
        results1.push({
          traitValue: option.value,
          disabled: false,
          forceDisplay: false,
          traitIndex: option.traitIndex,
          traitName: option.name,
          id: option.optionIndex,
          isSoldOut: option.isSoldOut,
          isUnavailable: option.isUnavailable,
          optionPrice: false,
          selected: option.optionIndex === 0
        });
      }
      return results1;
    })();
    results.push(new VariationsWidget.Collections.Option(data));
  }
  return results;
};

module.exports = VariationsWidget.Collections.Option;


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

var VariationsWidget;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = Backbone.Model.extend({
  initialize: function() {}
});

module.exports = VariationsWidget.Models.Option;


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = __webpack_require__(270);

VariationsWidget.Views.OptionCollection = Backbone.View.extend({
  events: {
    "change": "selectionChanged"
  },
  initialize: function() {
    var optionElementModel;
    _.bindAll(this, 'selectionChanged', 'render');
    return this.optionElementViews = (function() {
      var i, len, ref, results;
      ref = this.collection.models;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        optionElementModel = ref[i];
        results.push(new VariationsWidget.Views.Option({
          el: "#trait-" + optionElementModel.get('traitIndex') + "-" + optionElementModel.get('id'),
          model: optionElementModel
        }));
      }
      return results;
    }).call(this);
  },
  render: function() {
    var i, len, optionElementView, ref, results;
    ref = this.optionElementViews;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      optionElementView = ref[i];
      results.push(optionElementView.render());
    }
    return results;
  },
  isSelectedOptionDisabled: function(selectElement) {
    return selectElement != null ? selectElement.options[selectElement.selectedIndex].disabled : void 0;
  },
  selectionChanged: function(e) {
    var $currentElement, model, value;
    $currentElement = $(e.currentTarget)[0];
    if (VariationsWidget.controller.ie7 && this.isSelectedOptionDisabled($currentElement)) {
      $currentElement.selectedIndex = 0;
    }
    value = $(e.currentTarget).val();
    model = this.collection.chosen(value);
    return VariationsWidget.controller.render({
      trait: this.collection.models[0].get('traitName'),
      selection: value,
      id: model.get('id')
    });
  }
});

VariationsWidget.Views.OptionCollection.create = function(collections) {
  var i, index, len, results, trait;
  results = [];
  for (index = i = 0, len = collections.length; i < len; index = ++i) {
    trait = collections[index];
    results.push(new VariationsWidget.Views.OptionCollection({
      collection: trait,
      el: "#trait-" + index
    }));
  }
  return results;
};

module.exports = VariationsWidget.Views.OptionCollection;


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (true) {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && ("function" !== 'undefined')) _ = __webpack_require__(1);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);


/***/ }),

/***/ 270:
/***/ (function(module, exports) {

if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = Backbone.View.extend({
  initialize: function() {
    _.bindAll(this, 'render');
    this.model.bind('change:disabled', this.render);
    if (VariationsWidget.printSoldOut) {
      this.model.bind('change:forceDisplay', this.render);
    }
    if (VariationsWidget.printOptionPrice) {
      this.model.bind('change:optionPrice', this.render);
      return this.model.bind('change:selected', this.render);
    }
  },
  render: function() {
    this.$el.attr('disabled', this.model.get('disabled'));
    this.clearSoldOut();
    if (VariationsWidget.printSoldOut && this.model.get('disabled')) {
      this.renderSoldOut();
    }
    if (VariationsWidget.printOptionPrice) {
      return this.renderPrintOptionPrice();
    }
  },
  clearSoldOut: function() {
    this.$el.removeClass('force-display');
    this.$el.find('.sold-out-text').remove();
  },
  renderSoldOut: function() {
    var soldOutText, string;
    if (!this.model.get('forceDisplay')) {
      return;
    }
    soldOutText = typeof I18n !== "undefined" && I18n !== null ? I18n.t('js.modules.variations.sold_out') : void 0;
    string = "<span class=\"sold-out-text\">" + soldOutText + "</span>";
    this.$el.addClass('force-display');
    this.$el.prepend(string);
  },
  renderPrintOptionPrice: function() {
    var isSelected, optionPrice, string;
    optionPrice = this.model.get('optionPrice');
    isSelected = this.model.get('selected');
    string = "<span class=\"option-price\">(" + optionPrice + ")</span>";
    this.$el.find('.option-price').remove();
    if (optionPrice && !isSelected) {
      return this.$el.append(string);
    }
  }
});

module.exports = VariationsWidget.Views.Option;


/***/ }),

/***/ 271:
/***/ (function(module, exports) {

if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Error = Backbone.View.extend({
  show: function() {
    return this.$el.show();
  },
  hide: function() {
    return this.$el.hide();
  }
});

module.exports = VariationsWidget.Views.Error;


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

var Cart, VariationsWidget,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

Cart = window.Cart != null ? window.Cart : window.Cart = {};

Cart.Helpers = __webpack_require__(48);

VariationsWidget.Controller = (function() {
  function Controller() {
    this.findSelectedCollections = bind(this.findSelectedCollections, this);
    this.findDefaultCollections = bind(this.findDefaultCollections, this);
    this.isSelectionDefault = bind(this.isSelectionDefault, this);
    var ref;
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub.user.browser : void 0) === 'IE' && OptimizeSuite.TrackingHub.user.browserVersion === '7.0') {
      this.ie7 = true;
    }
    if (typeof I18n !== "undefined" && I18n !== null) {
      this.i18n = I18n.scoped();
    }
    this.updateSelectElements("", true);
    this.availableOptions = this.getAvailableOptions();
    this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
    this.clearTraitsOnCarouselSelection = VariationsWidget.clearTraitsOnCarouselSelection;
    this.$selectElements = $('#variation-traits').find('.variation-trait');
    if ((ref = VariationsWidget.preSelectTraits) != null ? ref.length : void 0) {
      this.makeSelectionsViaPreselection();
    } else {
      this.updateSelectionsToDefault();
    }
  }

  Controller.prototype.render = function(latestSelection, updateCarousel) {
    if (updateCarousel == null) {
      updateCarousel = true;
    }
    if (latestSelection.selection != null) {
      this.updateSelections(latestSelection);
      this.updateSelectElements(latestSelection.trait);
      this.availableOptions = this.getAvailableOptions();
      this.cheapestOption = this.getCheapestAvailableOption(this.availableOptions);
      this.updatePricing(this.cheapestOption, this.availableOptions.length);
      if (updateCarousel) {
        this.updateCarousel();
      }
      this.removeErrorMessages();
    }
  };

  Controller.prototype.updateSelectionsToDefault = function() {
    var i, len, ref, results, selectElement;
    ref = this.$selectElements || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      selectElement = ref[i];
      results.push($(selectElement).find('option:eq(0)').prop('selected', true));
    }
    return results;
  };

  Controller.prototype.updateSelections = function(latestSelection) {
    var collection, i, len, ref;
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      if (collection.models[0].get('traitName') === latestSelection.trait) {
        collection.setSelected(latestSelection.id);
        break;
      }
    }
  };

  Controller.prototype.updateSelectElements = function(latestSelection, updateAll) {
    var availableValues, collection, conditions, enabledOptions, enabledValues, i, j, k, l, lastSelection, len, len1, len2, len3, len4, m, model, option, ref, ref1, ref2, trait, traitName, unavailableOptions, unavailableValues, value;
    if (updateAll == null) {
      updateAll = false;
    }
    if (VariationsWidget.printOptionPrice) {
      updateAll = true;
    }
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      traitName = collection.models[0].get('traitName');
      if (traitName !== latestSelection || updateAll) {
        conditions = this.getConditions(collection.selected());
        lastSelection = _.keys(conditions).length === VariationsWidget.collections.length - 1;
        enabledOptions = [];
        unavailableOptions = [];
        if (!$.isEmptyObject(conditions)) {
          enabledOptions = _.where(VariationsWidget.options, conditions);
        } else {
          enabledOptions = VariationsWidget.options;
        }
        enabledValues = _.pluck(enabledOptions, traitName);
        unavailableValues = _.uniq(enabledValues);
        availableValues = [];
        for (j = 0, len1 = enabledOptions.length; j < len1; j++) {
          option = enabledOptions[j];
          for (k = 0, len2 = unavailableValues.length; k < len2; k++) {
            value = unavailableValues[k];
            if ((value === option[traitName]) && this.isOptionAvailable(option)) {
              availableValues.push(value);
            }
          }
        }
        unavailableValues = _.difference(unavailableValues, availableValues);
        enabledValues.unshift((this.i18n.t('js.modules.variations.selector')) + " " + traitName);
        ref1 = VariationsWidget.collections;
        for (l = 0, len3 = ref1.length; l < len3; l++) {
          trait = ref1[l];
          if (trait.models[0].get('traitName') === traitName) {
            ref2 = trait.models;
            for (m = 0, len4 = ref2.length; m < len4; m++) {
              model = ref2[m];
              this.setOptionState(model, enabledValues, unavailableValues);
              if (lastSelection && (conditions[traitName] == null)) {
                this.setOptionPrice(model, enabledValues, enabledOptions);
              } else if (conditions[traitName] == null) {
                this.setOptionFromPrice(model, enabledValues, enabledOptions);
              } else {
                model.set('optionPrice', false);
              }
            }
          }
        }
      }
    }
    if (this.ie7) {
      $('option').removeClass("ie7-color");
      return $('option[disabled]').addClass("ie7-color");
    }
  };

  Controller.prototype.setOptionState = function(model, enabledValues, unavailableValues) {
    var forceDisplay, printSoldOut;
    printSoldOut = VariationsWidget.printSoldOut;
    if (model.id === 0 || (_.contains(enabledValues, model.get('traitValue')))) {
      if (model.get('isSoldOut') || model.get('isUnavailable') || ((unavailableValues != null) && (_.contains(unavailableValues, model.get('traitValue'))))) {
        model.set('disabled', true);
      } else {
        model.set('disabled', false);
      }
      model.set('forceDisplay', printSoldOut === true);
    } else {
      model.set('disabled', true);
      forceDisplay = printSoldOut === true && !VariationsWidget.isGetaways;
      model.set('forceDisplay', forceDisplay);
    }
  };

  Controller.prototype.setOptionFromPrice = function(model, enabledValues, enabledOptions) {
    var cheapestOption, modelID, name, printOptionPrice, selected, traitOptions, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    traitOptions = _.filter(enabledOptions, (function(item) {
      return item[name] === value;
    }));
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      cheapestOption = this.getCheapestAvailableOption(traitOptions);
      if (cheapestOption != null) {
        model.set('optionPrice', I18n.t('js.modules.variations.from_price', {
          minPrice: cheapestOption.newPrice
        }));
      }
    }
  };

  Controller.prototype.setOptionPrice = function(model, enabledValues, enabledOptions) {
    var i, len, modelID, name, option, printOptionPrice, selected, value;
    printOptionPrice = VariationsWidget.printOptionPrice;
    if (!printOptionPrice) {
      return;
    }
    value = model.get('traitValue');
    name = model.get('traitName');
    selected = model.get('selected');
    modelID = model.get('id');
    if (selected || modelID === 0) {
      return model.set('optionPrice', false);
    }
    if (_.contains(enabledValues, value)) {
      for (i = 0, len = enabledOptions.length; i < len; i++) {
        option = enabledOptions[i];
        if (value === option[name]) {
          model.set('optionPrice', option.newPrice);
        }
      }
    }
  };

  Controller.prototype.getConditions = function(selected) {
    var conditions, i, len, ref, tempCollection, tempSelected, tempSelectedTraitValue;
    conditions = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      tempCollection = ref[i];
      tempSelected = tempCollection.selected();
      tempSelectedTraitValue = tempSelected.get('traitValue');
      if (tempSelectedTraitValue !== selected.get('traitValue') && !this.isSelectionDefault(tempSelectedTraitValue)) {
        conditions[tempSelected.get('traitName')] = tempSelectedTraitValue;
      }
    }
    return conditions;
  };

  Controller.prototype.getAvailableOptions = function() {
    var collection, i, len, options, properties, ref, selectedTrait, selectedTraitValue;
    properties = {};
    ref = VariationsWidget.collections;
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitValue = selectedTrait.get('traitValue');
      if (!this.isSelectionDefault(selectedTraitValue)) {
        properties[selectedTrait.get('traitName')] = selectedTraitValue;
      }
    }
    if ($.isEmptyObject(properties)) {
      options = VariationsWidget.options;
    } else {
      options = _.where(VariationsWidget.options, properties);
    }
    return options;
  };

  Controller.prototype.getCheapestAvailableOption = function(availableOptions) {
    var currentCheapest, i, len, option;
    currentCheapest = void 0;
    for (i = 0, len = availableOptions.length; i < len; i++) {
      option = availableOptions[i];
      if (this.isOptionAvailable(option) && (currentCheapest === void 0 || (option.amount < currentCheapest.amount))) {
        currentCheapest = option;
      }
    }
    return currentCheapest || availableOptions[0];
  };

  Controller.prototype.overridePriceDataWithSaleInfo = function(priceData, option) {
    var sale;
    if ((option != null ? option.regularPrice : void 0) == null) {
      return;
    }
    sale = {};
    if (option.regularPrice) {
      _.extend(sale, {
        urgencyPricing: {
          regularPrice: option.regularPrice,
          newPrice: option.newPrice,
          pricingMetadata: option.pricingMetadata
        }
      });
    }
    if (sale !== {}) {
      return _.extend(priceData, {
        sale: sale
      });
    }
  };

  Controller.prototype.updatePricing = function(cheapestOption, length) {
    var priceData;
    priceData = {
      dealUuid: VariationsWidget.uuid,
      id: cheapestOption.id,
      value: cheapestOption.oldPrice,
      percent: cheapestOption.discount,
      savings: cheapestOption.savePrice,
      price: cheapestOption.newPrice,
      lengthClass: cheapestOption.lengthClass,
      buyUrl: this.buyButtonUrl(cheapestOption),
      uuid: cheapestOption.uuid,
      variationsSelected: length === 1 && !this.areAnySelectionsDefault(VariationsWidget.collections),
      hideOriginalPriceAndDiscount: cheapestOption.hideOriginalPriceAndDiscount,
      showDifferenceMessage: cheapestOption.showDifferenceMessage,
      soldMessage: cheapestOption.soldMessage,
      shippingValue: cheapestOption.shippingValue,
      valueSourceMetadata: cheapestOption.valueSourceMetadata
    };
    if (cheapestOption.affirmAmount != null) {
      _.extend(priceData, {
        affirmAmount: cheapestOption.affirmAmount
      });
    }
    this.overridePriceDataWithSaleInfo(priceData, cheapestOption);
    window.VariationsWidget.currentOptionInfo = priceData;
    window.DealEventPipe.trigger("priceUpdate", priceData);
    if (payload.goodsWarranty) {
      return window.DealEventPipe.trigger("goodsWarrantyUpdate", priceData);
    }
  };

  Controller.prototype.buyButtonUrl = function(cheapestOption) {
    var ref;
    if ((ref = cheapestOption.externalUrl) != null ? ref.length : void 0) {
      return cheapestOption.externalUrl;
    }
    if ((typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0) && !payload.shouldDisableGoodsCart) {
      return Cart.Helpers.generateCartUrl(cheapestOption.uuid, VariationsWidget.uuid);
    } else {
      return cheapestOption.url;
    }
  };

  Controller.prototype.updateCarousel = function() {
    var data, i, index, len, selectedIndices, selectedTrait;
    data = {};
    selectedIndices = this.findSelectedCollections(VariationsWidget.collections);
    for (i = 0, len = selectedIndices.length; i < len; i++) {
      index = selectedIndices[i];
      selectedTrait = VariationsWidget.collections[index].selected();
      data[selectedTrait.get('traitName')] = selectedTrait.get('traitValue');
    }
    return window.DealEventPipe.trigger('traitsUpdate', {
      selectedTraits: data
    });
  };

  Controller.prototype.selectTraitsFromPotentialValues = function(traitsHash) {
    var selections, traitName, traitValues;
    if (!this.clearTraitsOnCarouselSelection) {
      return;
    }
    selections = [];
    for (traitName in traitsHash) {
      traitValues = traitsHash[traitName];
      if (traitValues.length === 1) {
        selections.push({
          trait: traitName,
          selection: traitValues[0]
        });
      }
    }
    if (selections.length < 1) {
      return;
    }
    this.clearSelections();
    return this.makeSelections(selections);
  };

  Controller.prototype.makeSelectionsViaPreselection = function() {
    var collection, i, j, len, len1, option, ref, ref1, selections, trait;
    option = _.findWhere(VariationsWidget.options, {
      uuid: VariationsWidget.dealOptionUuid
    });
    if (!((option != null) && this.isOptionAvailable(option))) {
      return;
    }
    selections = [];
    ref = VariationsWidget.preSelectTraits || [];
    for (i = 0, len = ref.length; i < len; i++) {
      trait = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get("traitName") === trait) {
          selections.push({
            trait: trait,
            selection: option[trait]
          });
          break;
        }
      }
    }
    this.makeSelections(selections);
    return this.updateCarousel();
  };

  Controller.prototype.clearSelections = function() {
    var collection, data, i, len, ref, results, selectedTrait, selectedTraitName, selection;
    ref = VariationsWidget.collections || [];
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      collection = ref[i];
      selectedTrait = collection.selected();
      selectedTraitName = selectedTrait.get('traitName');
      if (!this.isSelectionDefault(selectedTrait.get('traitValue'))) {
        selection = this.i18n.t('js.modules.variations.select', {
          name: selectedTraitName
        });
        data = {
          trait: selectedTraitName,
          selection: selection,
          id: 0
        };
        $("#trait-" + (selectedTrait.get('traitIndex'))).val(selection);
        if ($("#trait-" + (selectedTrait.get('traitIndex'))).val() == null) {
          $("#trait-" + (selectedTrait.get('traitIndex'))).prop('selectedIndex', 0);
        }
        results.push(this.render(data, false));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  Controller.prototype.makeSelections = function(selections) {
    var collection, element, i, j, len, len1, ref, ref1, trait;
    ref = selections || [];
    for (i = 0, len = ref.length; i < len; i++) {
      element = ref[i];
      ref1 = VariationsWidget.collections || [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        collection = ref1[j];
        if (collection.models[0].get('traitName') === element.trait) {
          trait = collection.findWhere({
            traitValue: element.selection
          });
          if (!trait.get('disabled')) {
            element['id'] = trait.get('id');
            $('#trait-' + collection.models[0].get('traitIndex')).val(element.selection);
            this.render(element, false);
            break;
          }
        }
      }
    }
  };

  Controller.prototype.showErrorMessages = function() {
    var defaultCollections, i, index, len, results;
    VariationsWidget.error.show();
    VariationsWidget.error.$el.addClass("icon-circle-alert");
    defaultCollections = this.findDefaultCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = defaultCollections.length; i < len; i++) {
      index = defaultCollections[i];
      results.push($('#trait-' + index).addClass('error'));
    }
    return results;
  };

  Controller.prototype.removeErrorMessages = function() {
    var i, index, len, results, selectedCollections;
    if (!this.areAnySelectionsDefault(VariationsWidget.collections)) {
      VariationsWidget.error.hide();
    }
    selectedCollections = this.findSelectedCollections(VariationsWidget.collections);
    results = [];
    for (i = 0, len = selectedCollections.length; i < len; i++) {
      index = selectedCollections[i];
      results.push($('#trait-' + index).removeClass('error'));
    }
    return results;
  };

  Controller.prototype.areAnySelectionsDefault = function(collections) {
    return _.some(collections, (function(_this) {
      return function(collection) {
        return RegExp("(^" + (_this.i18n.t('js.modules.variations.selector')) + "|" + (_this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'));
      };
    })(this));
  };

  Controller.prototype.isSelectionDefault = function(selection) {
    return RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(selection);
  };

  Controller.prototype.findDefaultCollections = function(collections) {
    var collection, defaultCollections, i, index, len;
    defaultCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        defaultCollections.push(index);
      }
    }
    return defaultCollections;
  };

  Controller.prototype.findSelectedCollections = function(collections) {
    var collection, i, index, len, selectedCollections;
    selectedCollections = [];
    for (index = i = 0, len = collections.length; i < len; index = ++i) {
      collection = collections[index];
      if (!RegExp("(^" + (this.i18n.t('js.modules.variations.selector')) + "|" + (this.i18n.t('js.modules.variations.selector')) + "$)", 'i').test(collection.selected().get('traitValue'))) {
        selectedCollections.push(index);
      }
    }
    return selectedCollections;
  };

  Controller.prototype.isOptionAvailable = function(option) {
    if (option == null) {
      return false;
    }
    return !(option.isSoldOut || option.isUnavailable);
  };

  return Controller;

})();

module.exports = VariationsWidget.Controller;


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env browser, jquery */
/* globals CountdownTimer, _ */



__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);

var StickyHandler = __webpack_require__(245);

var DealHighlights = window.DealHighlights != null ? window.DealHighlights : window.DealHighlights = {};

var ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000;
var PRIMARY_MESSAGE_TIMEOUT_TOUCH = 3000;

DealHighlights.fixWidthData = {};
DealHighlights.fixWidth = function (timerData) {
  var isSticky = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (timerData.isTouchRequest) {
    var MAX_TIMESTAMP_WIDTH = isSticky ? 57 : 62;

    // get current widths
    var containerWidth = $('.deal-highlights .urgency.columns .text').width();
    var textWidth = $('.deal-highlights .urgency.columns .text .countdown-text').outerWidth(true);

    var $timestamp = $('.deal-highlights .urgency.columns .text .countdown-timestamp');
    var $timer = $('.deal-highlights .urgency.columns .text .countdown-timer');

    var hasDays = timerData.timeLeft.days > 0;
    if (hasDays) {
      $timer.addClass('with-days');
    }

    if (!DealHighlights.fixWidthData.daysWidth) {
      var timerWidth = $timer.width();
      var timestampWidth = $timestamp.width();
      DealHighlights.fixWidthData.daysWidth = timerWidth - timestampWidth;
    }

    var availableSpace = containerWidth - textWidth;
    var neededSpace = hasDays ? MAX_TIMESTAMP_WIDTH + DealHighlights.fixWidthData.daysWidth : MAX_TIMESTAMP_WIDTH;

    var fixingClass = '';
    if (availableSpace < neededSpace) {
      fixingClass += ' two-lines';
    }

    if (hasDays && (containerWidth < neededSpace || $timestamp.height() + 2 < $timer.height())) {
      fixingClass += ' three-lines';
    }

    $timer.removeClass('two-lines three-lines').addClass(fixingClass);
  }
};

DealHighlights.rotateMessages = function (messagesContainer) {
  var loopMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var currentMessage = messagesContainer.find('.primary');
  var nextMessage = messagesContainer.find('.secondary');

  var switchMessage = function switchMessage() {
    currentMessage.addClass('fade-out').removeClass('fade-in');
    nextMessage.addClass('fade-in').removeClass('fade-out');
    if (loopMessages) {
      var ref = currentMessage;
      currentMessage = nextMessage;
      nextMessage = ref;
    }
  };

  if (loopMessages) {
    return window.setInterval(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH + ACTIVATE_PRIMARY_MESSAGE_TIMEOUT);
  }
  return window.setTimeout(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH);
};

DealHighlights.init = function (_ref, done) {
  var dealHighlights = _ref.dealHighlights;

  if (!dealHighlights) {
    return;
  }

  var tiles = dealHighlights.tiles;

  if (dealHighlights.leftTile || dealHighlights.middleTile || dealHighlights.rightTile) {
    tiles = [dealHighlights.leftTile, dealHighlights.middleTile, dealHighlights.rightTile].filter(function (a) {
      return a;
    });
  }

  var activateRotatingMessaging = function activateRotatingMessaging($element, loopMessages) {
    if ($element.attr('data-activated') === 'true') {
      return;
    }
    $element.attr('data-activated', 'true');
    DealHighlights.rotateMessages($element, loopMessages);
  };

  var scrollHandler = function scrollHandler(e, $element, loopMessages) {
    if ($(this).scrollTop() > 0) {
      $(this).off(e);
      activateRotatingMessaging($element, loopMessages);
    }
  };

  var bindHighlightLinksNavigation = function bindHighlightLinksNavigation(id) {
    var $anchorElement = $('.deal-highlights a[href="#' + id + '"]');

    return window.TouchDeal != null ? window.TouchDeal.bindTargetNavigation($anchorElement) : undefined;
  };

  var prepareWindowHandlers = function prepareWindowHandlers($element) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ACTIVATE_PRIMARY_MESSAGE_TIMEOUT;
    var loopMessages = arguments[2];

    window.setTimeout(function () {
      return activateRotatingMessaging($element, loopMessages);
    }, timeout);

    return $(window).on('scroll', function (e) {
      return scrollHandler(e, $element, loopMessages);
    });
  };

  var timerData = void 0;
  for (var i = 0; i < tiles.length; i += 1) {
    var tile = tiles[i];
    if (tile.secondaryMessage) {
      (function () {
        var messageTimer = tile.messageTimerInSec * 1000;
        var loopMessages = tile.loop === true;
        prepareWindowHandlers($('.t-main-inner .deal-highlights, #purchase-cluster .deal-highlights, .multi-option-overlay-cluster .deal-highlights'), messageTimer, loopMessages);

        if ($('#options-pane .deal-highlights').length) {
          window.UrlHashChange.eventBus.board('showHideOptions', function () {
            return prepareWindowHandlers($('#options-pane .deal-highlights'), ACTIVATE_PRIMARY_MESSAGE_TIMEOUT, loopMessages);
          });
        }
      })();
    } else if (tile.jsTimerData) {
      timerData = _.extend(tile.jsTimerData, {
        el: '.deal-highlights .countdown-timer',
        translationScope: 'js.modules.groupon-deal-timer.tile'
      });

      CountdownTimer.init({ timerData: timerData });
      DealHighlights.fixWidth(timerData);
    }
  }

  bindHighlightLinksNavigation('touch-tips');

  if (dealHighlights.tilesMeta && dealHighlights.tilesMeta.isStickyUMS) {
    var options = {
      $element: $('.t-main .deal-highlights.sticky-ums'),
      $wrapper: $('.t-main .deal-highlights-wrapper')
    };
    if (timerData !== undefined) {
      options.onStateChange = function () {
        $('.t-main .deal-highlights.sticky-ums')[0].addEventListener('transitionend', DealHighlights.fixWidth.bind(null, timerData, true), {
          once: true
        });
      };
    }

    DealHighlights.stickyHandler = new StickyHandler(options);
  }
  done();
};

module.exports = DealHighlights;

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AdUnitLazyLoader = {
  load: function load() {
    return $('.ad-widget iframe').attr('src', function () {
      return $(this).attr('data-src');
    });
  }
};

window.AdUnitLazyLoader = AdUnitLazyLoader;
module.exports = AdUnitLazyLoader;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

var FIXED_PURCHASE_QTY, confirmationRedirect, getIovationBlackBox, getTotal, hasErrors, lazyLoadJs, receiptRedirect, shouldBucketTheUserIntoExp, showPaymentSheet;

lazyLoadJs = __webpack_require__(218).lazyLoadJs;

FIXED_PURCHASE_QTY = 1;

getTotal = function(amount, type) {
  var total;
  amount = amount.replace(/\$|\s/g, '');
  total = {
    label: I18n.t('js.modules.applepay.total'),
    amount: amount
  };
  if (type) {
    total.type = type;
  }
  return total;
};

confirmationRedirect = function(url) {
  return window.location = url + "&msg=complete_failed";
};

receiptRedirect = function(url) {
  return window.location = url;
};

hasErrors = function(res) {
  var ref, ref1;
  return ((ref = res.flashErrors) != null ? ref.length : void 0) > 0 || ((ref1 = res.apiErrors) != null ? ref1.length : void 0) > 0 || res.error;
};

showPaymentSheet = function(opts) {
  var confirmationUrl, countryCode, csrf, currencyCode, dealId, ioBlackBox, matches, optionId, paymentRequest, session, totalAmount;
  totalAmount = opts.totalAmount, currencyCode = opts.currencyCode, csrf = opts.csrf, confirmationUrl = opts.confirmationUrl, ioBlackBox = opts.ioBlackBox;
  countryCode = I18n.country;
  matches = /\/deals\/(.+)\/confirmation\?pledge_id=([0-9]+)/.exec(confirmationUrl);
  dealId = matches[1];
  optionId = matches[2];
  if (!dealId || !optionId) {
    window.location = confirmationUrl;
    return;
  }
  paymentRequest = {
    currencyCode: currencyCode,
    countryCode: countryCode,
    total: getTotal(totalAmount),
    supportedNetworks: ['amex', 'discover', 'masterCard', 'visa'],
    merchantCapabilities: ['supports3DS'],
    requiredBillingContactFields: ['postalAddress', 'email']
  };
  session = new ApplePaySession(1, paymentRequest);
  session.onpaymentauthorized = function(event) {
    var billingContact, payload, ref, token;
    ref = event.payment, billingContact = ref.billingContact, token = ref.token;
    payload = {
      ioBlackBox: ioBlackBox,
      items: [
        {
          deal_id: dealId,
          option_id: optionId,
          quantity: FIXED_PURCHASE_QTY
        }
      ],
      encrypted_payment_data: JSON.stringify(token.paymentData),
      type: 'applepay',
      billing_record: {
        payment_id: 'applepay',
        type: 'applepay',
        street_address_1: billingContact.addressLines.join(', '),
        country: billingContact.country,
        city: billingContact.locality,
        state: billingContact.administrativeArea,
        postal_code: billingContact.postalCode
      }
    };
    return $.ajax({
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      dataType: 'json',
      url: '/deals/new/orders',
      headers: {
        "x-csrf-token": csrf
      },
      data: payload,
      success: function(data) {
        if (hasErrors(data)) {
          session.completePayment(ApplePaySession.STATUS_FAILURE);
          return confirmationRedirect(confirmationUrl);
        } else {
          session.completePayment(ApplePaySession.STATUS_SUCCESS);
          return receiptRedirect(data.url);
        }
      },
      error: function() {
        session.completePayment(ApplePaySession.STATUS_FAILURE);
        return confirmationRedirect(confirmationUrl);
      }
    });
  };
  session.onpaymentmethodselected = function(e) {
    return session.completePaymentMethodSelection(getTotal(totalAmount, 'final'), []);
  };
  session.onvalidatemerchant = function(arg) {
    var validationURL;
    validationURL = arg.validationURL;
    return $.ajax({
      type: 'POST',
      dataType: 'json',
      data: {
        url: validationURL
      },
      headers: {
        "x-csrf-token": csrf
      },
      url: '/checkout/payment/validation',
      success: function(merchantSession) {
        return session.completeMerchantValidation(merchantSession);
      }
    });
  };
  return session.begin();
};

shouldBucketTheUserIntoExp = function(expName, cb) {
  return Finch.experiment(expName, {
    Control: function() {
      return cb(false);
    },
    Treatment: function() {
      return cb(true);
    }
  });
};

getIovationBlackBox = function(iovationUrl, cb) {
  window.io_bbout_element_id = 'ioBlackBox';
  window.io_install_flash = false;
  window.io_enable_rip = true;
  window.io_install_stm = false;
  window.io_exclude_stm = 12;
  $('body').append("<input type='hidden' name='" + io_bbout_element_id + "' id='" + io_bbout_element_id + "'>");
  return lazyLoadJs(iovationUrl, function() {
    return cb($("#" + io_bbout_element_id).val());
  });
};

module.exports = {
  hasValidConfirmationLink: function(href) {
    return href.match(/\/deals\/.+\/confirmation\?pledge_id=[0-9]+/i);
  },
  start: function(opts, getTotalAmount, getApplePayButton, renderApplePayFeature, updatePromoCodeHandler, getConfirmationUrl, expName) {
    if (!(window.ApplePaySession && opts.isApplePayEnabled)) {
      return;
    }
    return ApplePaySession.canMakePaymentsWithActiveCard(opts.appleMerchantId).then(function(canMakePayments) {
      OptimizeSuite.TrackingHub.add('[applepay-deal-page]', {
        canMakePayments: canMakePayments
      });
      if (!canMakePayments) {
        return;
      }
      return $.get('/deals/proxy/user/valid', function(arg) {
        var isApplePayEligible;
        isApplePayEligible = arg.isApplePayEligible;
        if (!isApplePayEligible) {
          return;
        }
        return shouldBucketTheUserIntoExp(expName, function(res) {
          if (!res) {
            return;
          }
          return getIovationBlackBox(opts.iovationUrl, function(ioBlackBox) {
            updatePromoCodeHandler();
            renderApplePayFeature();
            return getApplePayButton().click(function(e) {
              var totalAmount;
              totalAmount = getTotalAmount();
              showPaymentSheet(_.extend({}, opts, {
                totalAmount: totalAmount,
                ioBlackBox: ioBlackBox,
                confirmationUrl: getConfirmationUrl()
              }));
              return false;
            });
          });
        });
      });
    });
  }
};


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

var MemberOnly;

MemberOnly = window.MemberOnly != null ? window.MemberOnly : window.MemberOnly = {};

MemberOnly.init = function(arg, done) {
  var $tooltip, expectedSize;
  arg;
  expectedSize = $(".member-only").width();
  $tooltip = $("#member_only_tooltip");
  $tooltip.css("width", expectedSize);
  return done();
};

module.exports = MemberOnly;


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var TEMPLATES;

TEMPLATES = {
  modal: __webpack_require__(278)
};

window.IframeLogin = {
  init: function(arg, done) {
    var iframeLogin;
    iframeLogin = arg.iframeLogin;
    this.authenticated = iframeLogin != null ? iframeLogin.authenticated : void 0;
    if (this.authenticated == null) {
      this.authenticated = true;
    }
    if (this.authenticated) {
      return typeof done === "function" ? done() : void 0;
    }
    return $((function(_this) {
      return function() {
        _this.$modal = $('#login-modal');
        _this.$iframe = _this.$modal.find('iframe');
        _this.iframeName = _this.$iframe.attr('name');
        IframeLogin.reloadBindings();
        if (iframeLogin != null ? iframeLogin.lazyLoad : void 0) {
          $(window).load(function() {
            return IframeLogin.lazyLoadIframe();
          });
        }
        return typeof done === "function" ? done() : void 0;
      };
    })(this));
  },
  getTemplate: function(args) {
    return TEMPLATES.modal.render(args);
  },
  go: function(path, data) {
    var key, value;
    if (data) {
      path += "?ref=" + (encodeURIComponent(this.destination));
      for (key in data) {
        value = data[key];
        path += "&" + key + "=" + value;
      }
    }
    return window.location.assign(path);
  },
  lazyLoadIframe: function() {
    var ref, url;
    if (!((ref = IframeLogin.$iframe) != null ? ref.length : void 0)) {
      return;
    }
    if ((url = IframeLogin.$iframe.attr('data-src')) && !IframeLogin.$iframe.attr('src')) {
      return IframeLogin.$iframe.attr('src', url);
    }
  },
  reloadBindings: function(el) {
    if (el == null) {
      el = document.body;
    }
    return $(el).find('[data-login-required]').on('click', function(e) {
      var $this;
      e.preventDefault();
      $this = $(this);
      return IframeLogin.openModal($this.attr('href'));
    });
  },
  openModal: function(path) {
    var ref, ref1, ref2;
    if (path == null) {
      path = window.location.href;
    }
    this.destination = path;
    GIG.Modal.open({
      el: this.$modal
    });
    return (ref = frames[this.iframeName]) != null ? (ref1 = ref.IframeLogin) != null ? (ref2 = ref1.iframeView) != null ? typeof ref2.resetHeight === "function" ? ref2.resetHeight() : void 0 : void 0 : void 0 : void 0;
  },
  success: function(data) {
    return window.location.assign(this.destination);
  },
  updateHeight: function(height) {
    return this.$iframe.attr('height', height);
  }
};

if ((typeof module !== "undefined" && module !== null ? module.exports : void 0) != null) {
  module.exports = IframeLogin;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(!t.s(t.f("authenticated",c,p,1),c,p,1,0,0,"")){t.b("  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">");t.b("\n" + i);t.b("    <div class=\"modal-body\">");t.b("\n" + i);t.b("      <a class=\"close-modal icon-x\"></a>");t.b("\n" + i);t.b("      <iframe name=\"modal-login\" ");if(t.s(t.f("lazyLoad",c,p,1),c,p,0,200,205,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("data-");});c.pop();}t.b("src=\"");t.b(t.v(t.f("iframeSrc",c,p,0)));t.b("\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};return t.fl(); },partials: {}, subs: {  }}, "{{^ authenticated }}\n  <div id=\"login-modal\" class=\"modal\" data-bhw=\"LoginModal\">\n    <div class=\"modal-body\">\n      <a class=\"close-modal icon-x\"></a>\n      <iframe name=\"modal-login\" {{# lazyLoad }}data-{{/ lazyLoad }}src=\"{{ iframeSrc }}\" frameBorder=\"0\" scrolling=\"no\" width=\"265\" height=\"425\"></iframe>\n    </div>\n  </div>\n{{/ authenticated }}\n", H);return T; }();

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})( true ? exports : Hogan);


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})( true ? exports : Hogan);


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env browser, jquery */
/* globals window */



window.Backbone = __webpack_require__(27);

window.Backbone.$ = window.$;

__webpack_require__(24);
__webpack_require__(252);
__webpack_require__(414);
__webpack_require__(416);
__webpack_require__(253);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(261);
__webpack_require__(217);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(120);
__webpack_require__(417);
__webpack_require__(276);
__webpack_require__(418);
__webpack_require__(219);
__webpack_require__(97).polyfill();

// external packages
__webpack_require__(277);

// performance experiment tracking
var sendExperimentTrackyMessage = __webpack_require__(221);

$(window).load(function () {
  var Groupon = window.Groupon;
  Groupon.Performance.pageReady();
  if (window.AdUnitLazyLoader != null) {
    window.AdUnitLazyLoader.load();
  }
  return sendExperimentTrackyMessage();
});

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

var BuyButton, MagicEventBus;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

MagicEventBus = __webpack_require__(119);

BuyButton.View = __webpack_require__(415);

BuyButton.resetMultiOptionLink = function(payload) {
  return $(window).on('pageshow', function() {
    var $newSelectedInput, $wrapper, buyLink, linkWithNoQuantity;
    if ($('.multi-option-breakout').length) {
      $wrapper = '.multi-option-breakout';
      buyLink = $('#buy-link').attr('href');
    }
    if (!buyLink) {
      return;
    }
    linkWithNoQuantity = BuyButton.removeQuantityParam(buyLink);
    $newSelectedInput = $($wrapper + ' input[value="' + linkWithNoQuantity + '"]');
    return $newSelectedInput.prop('checked', true);
  });
};

BuyButton.removeQuantityParam = function(url) {
  return url.split(/&quantity=[0-9]+[^&]?/).join('');
};

BuyButton.init = function(payload, done) {
  var buyButton, goodsWarranty, handleBuyButton, iframeLogin, inlineVariations, variations;
  buyButton = payload.buyButton, iframeLogin = payload.iframeLogin, variations = payload.variations, inlineVariations = payload.inlineVariations, goodsWarranty = payload.goodsWarranty;
  this.eventBus = new MagicEventBus();
  if ((iframeLogin != null) && !iframeLogin.authenticated && !iframeLogin.disabledOnBuyButton) {
    handleBuyButton = function() {
      IframeLogin.openModal(BuyButton.view.$buyButton.attr('href'));
      return {
        stopTheBus: true
      };
    };
    this.eventBus.board('buy_button_clicked', handleBuyButton)(999);
  }
  return $((function(_this) {
    return function() {
      if (buyButton.multiOptionEnabled) {
        BuyButton.resetMultiOptionLink(payload);
      }
      _this.view = new BuyButton.View({
        multiOptionEnabled: buyButton.multiOptionEnabled,
        multiOptionInline: buyButton.multiOptionInline,
        buyButtonEnabled: buyButton.buyButtonEnabled,
        hasVariations: (variations != null) || (inlineVariations != null),
        goodsWarranty: goodsWarranty
      });
      return done();
    };
  })(this));
};

module.exports = BuyButton;


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

var Affirm, BuyButton, SCROLL_THRESHOLD, getBuyUrlWithShippingOptionData;

BuyButton = window.BuyButton != null ? window.BuyButton : window.BuyButton = {};

getBuyUrlWithShippingOptionData = __webpack_require__(75).getBuyUrlWithShippingOptionData;

Affirm = __webpack_require__(216);

SCROLL_THRESHOLD = 460;

BuyButton.View = Backbone.View.extend({
  el: "#purchase-cluster, .multi-option-overlay, .purchase_cluster_wrapper, #header-purchase-cluster",
  events: {
    "click a.buy-button:not(.external-buy)": "buyButtonClicked",
    "click .view-options a": "viewAllOptions",
    "click .multi-option-breakout input": "updateMultiOptionBreakoutButton",
    "click .multi-option-overlay-items input": "updateMultiOptionBreakoutButton",
    "click .multi-option-overlay-cluster a div.text": "goToTips"
  },
  initialize: function(arg) {
    var processLink;
    this.multiOptionEnabled = arg.multiOptionEnabled, this.multiOptionInline = arg.multiOptionInline, this.buyButtonEnabled = arg.buyButtonEnabled, this.hasVariations = arg.hasVariations;
    this.$buyContainer = this.$(".buy");
    this.$buyButton = this.$("a.buy-button");
    this.$giftButton = this.$("a.buy-for-friend");
    this.$dealHeroPrice = this.$(".deal-hero-price, .multi-option-overlay-cluster-price");
    this.$mainBtnPrice = this.$("#main-button-formatted-price");
    this.$priceBox = this.$(".price, .multi-option-overlay-cluster-price");
    this.$priceLabel = this.$(".price-label, .multi-option-overlay-cluster-price-label");
    this.$value = this.$("#discount-value, .discount-value, .breakout-option-value");
    this.$strikethroughPrice = this.$(".value-source-wrapper, .breakout-option-value");
    this.$valueSourceWrapper = this.$(".value-source-wrapper");
    this.$valueSourceLabel = this.$(".source-metadata-label");
    this.$valueSourceDescription = this.$(".source-metadata-description");
    this.$smallPrice = this.$(".discount-value");
    this.$multiOptionBreakout = this.$('.multi-option-breakout, .modal-body');
    this.$multiOptionOverlay = this.$el.filter('.multi-option-overlay');
    this.$multiOptions = this.$('.multi-option-breakout input, .multi-option-overlay-item input');
    this.$buyButtonLoader = this.$buyButton.find('.order-processing-loader');
    this.$finePrintDesc = $(".fine-print-description");
    this.$headerTitles = $(".header-title-item");
    this.$headerOptions = $(".header-options");
    if (typeof I18n !== "undefined" && I18n !== null) {
      this.i18n = I18n.scoped();
    }
    this.$discount = this.$(".breakout-messages .discount-message");
    this.$valueBox = this.$(".multi-option-overlay-cluster-value");
    this.$overlayCluster = this.$(".multi-option-overlay-cluster");
    this.$soldBox = this.$overlayCluster.find("div.sold-message");
    this.$discountBox = this.$overlayCluster.find("div.discount-message");
    this.$expirationBox = this.$overlayCluster.find("div.expiration");
    this.$overlayList = this.$('.multi-option-overlay-list');
    this.$overlayFade = this.$('.scroll-fade-overlay');
    this.$shippingFee = this.$('.shipping-value');
    this.$shippingFeeOverlay = this.$('.shipping-value-overlay');
    if (this.hasVariations) {
      this.$priceBox = this.$(".price, .multi-option-overlay-cluster-price, .breakout-option-price");
      this.$urgencyPricingMessage = this.$multiOptionBreakout.find('.urgency-pricing-label');
      this.$soldMessage = this.$multiOptionBreakout.find('.sold-message');
    }
    if (this.$multiOptionOverlay.length) {
      this.$discountPercent = this.$('#discount-percent, .discount-percent');
      this.$discountYouSave = this.$('#discount-you-save, .discount-you-save');
      this.$qtyBought = this.$('.qty-bought');
      this.$dealStatus = this.$('.deal-status');
      this.fixPossiblePriceOverflow();
    }
    this.hasBeenClicked = false;
    this.variationsSelected = false;
    if (this.multiOptionInline) {
      this.restoreOptionSelection();
    }
    processLink = (function(_this) {
      return function() {
        return _this.processLink();
      };
    })(this);
    BuyButton.eventBus.board('buy_button_clicked', processLink)(1000);
    window.DealEventPipe.on("priceUpdate", (function(_this) {
      return function(priceData) {
        _this.variationsSelected = priceData.variationsSelected;
        _this.$buyButton.removeClass("login-disabled");
        _this.updatePrice(priceData);
        _this.updateShippingCharge(priceData);
        _this.updateValue(priceData);
        _this.updateMSRP(priceData);
        _this.updateDiscount(priceData);
        _this.updateSoldMessage(priceData);
        _this.updateBuyButton(priceData);
        return _this.updateAffirmPrice(priceData);
      };
    })(this));
    return this.$overlayList.on('scroll', (function(_this) {
      return function() {
        return _this.handleFadeout();
      };
    })(this));
  },
  handleFadeout: function() {
    if (this.$overlayList[0].scrollHeight <= SCROLL_THRESHOLD) {
      return;
    }
    if (this.$overlayList.scrollTop() + this.$overlayList.innerHeight() >= this.$overlayList[0].scrollHeight) {
      if (this.$overlayFade.is(':visible')) {
        return this.$overlayFade.hide();
      }
    } else if (!this.$overlayFade.is(':visible')) {
      return this.$overlayFade.show();
    }
  },
  buyButtonClicked: function(e) {
    e.preventDefault();
    this.giftButtonClicked = false;
    return BuyButton.eventBus.go('buy_button_clicked', e);
  },
  shouldShowPriceInTwoRows: function() {
    var includeMargin;
    includeMargin = true;
    return this.$priceBox.outerWidth(includeMargin) + this.$smallPrice.outerWidth(includeMargin) > this.$dealHeroPrice.outerWidth(includeMargin);
  },
  setPriceWithSale: function(newPrice) {
    this.$priceBox.text(newPrice);
    return this.fixPossiblePriceOverflow();
  },
  setOfferLabel: function(offerLabel) {
    if (!(offerLabel != null ? offerLabel.length : void 0)) {
      return;
    }
    if (this.hasVariations) {
      this.$urgencyPricingMessage.text(offerLabel);
      this.$soldMessage.hide();
      return this.$priceBox.addClass('urgency-pricing');
    } else {
      offerLabel = "<span class='urgency-pricing-label'>" + offerLabel + "</span>";
      this.$dealHeroPrice.append(offerLabel);
      return this.$dealHeroPrice.addClass('urgency-pricing');
    }
  },
  cleanPriceBox: function() {
    if (this.hasVariations) {
      this.$urgencyPricingMessage.text('');
      this.$soldMessage.text('').show();
      return this.$priceBox.removeClass('urgency-pricing');
    } else {
      this.$priceBox.removeClass('two-rows');
      this.$priceBox.find('.urgency-pricing-label').remove();
      return this.$dealHeroPrice.removeClass('urgency-pricing');
    }
  },
  setPriceBox: function(price, sale, variationsSelected) {
    var ref;
    this.cleanPriceBox();
    if ((sale != null ? sale.urgencyPricing : void 0) != null) {
      this.setPriceWithSale(sale.urgencyPricing.newPrice);
      return this.setOfferLabel((ref = sale.urgencyPricing.pricingMetadata) != null ? ref.offerLabel : void 0, variationsSelected);
    } else if ((sale != null ? sale.offer : void 0) != null) {
      this.$mainBtnPrice.text(sale.offer.formattedNewPrice);
      return this.setPriceWithSale(sale.offer.formattedOldPrice);
    } else {
      return this.$priceBox.text(price);
    }
  },
  updatePrice: function(arg) {
    var lengthClass, price, ref, sale, variationsSelected;
    lengthClass = arg.lengthClass, price = arg.price, sale = arg.sale, variationsSelected = arg.variationsSelected;
    if (this.currentPriceClass) {
      this.$buyContainer.removeClass(this.currentPriceClass);
    }
    if (lengthClass) {
      this.$buyContainer.addClass(lengthClass);
    }
    this.setPriceBox(price, sale, variationsSelected);
    this.currentPriceClass = lengthClass;
    if (variationsSelected || ((ref = this.$strikethroughPrice) != null ? ref.length : void 0)) {
      this.$priceLabel.hide();
      this.$valueSourceWrapper.show();
      this.$valueSourceWrapper.css("display", "flex");
      return this.$value.show();
    } else {
      this.$priceLabel.show();
      this.$valueSourceWrapper.hide();
      return this.$value.hide();
    }
  },
  updateShippingCharge: function(priceData) {
    return this.$shippingFee.text(priceData.shippingValue);
  },
  updateClusterShippingCharge: function(shippingValue) {
    this.$shippingFee.text(shippingValue);
    return this.$shippingFeeOverlay.text(shippingValue);
  },
  updateAffirmPrice: function(arg) {
    var affirmAmount;
    affirmAmount = arg.affirmAmount;
    return Affirm.updateAffirmPrice(affirmAmount);
  },
  updateValue: function(arg) {
    var hideOriginalPriceAndDiscount, value;
    value = arg.value, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    return this.$value.html(hideOriginalPriceAndDiscount ? "" : value);
  },
  updateMSRP: function(arg) {
    var description, hideOriginalPriceAndDiscount, label, ref, ref1, valueSourceMetadata;
    valueSourceMetadata = arg.valueSourceMetadata, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount;
    if ((valueSourceMetadata != null ? valueSourceMetadata.label : void 0) && (valueSourceMetadata != null ? valueSourceMetadata.description : void 0) && !hideOriginalPriceAndDiscount) {
      label = valueSourceMetadata.label, description = valueSourceMetadata.description;
      this.$valueSourceLabel.html(label);
      return this.$valueSourceDescription.html(description);
    } else {
      if ((ref = this.$valueSourceLabel) != null) {
        ref.html("");
      }
      return (ref1 = this.$valueSourceDescription) != null ? ref1.html("") : void 0;
    }
  },
  updateDiscount: function(arg) {
    var discountHtml, hideOriginalPriceAndDiscount, percent, showDifferenceMessage;
    percent = arg.percent, hideOriginalPriceAndDiscount = arg.hideOriginalPriceAndDiscount, showDifferenceMessage = arg.showDifferenceMessage;
    if (!hideOriginalPriceAndDiscount) {
      if (showDifferenceMessage) {
        discountHtml = this.i18n.t('js.modules.buy_button.multi_option.difference_percentage', {
          rawDiscountPercentage: percent
        });
      } else {
        discountHtml = this.i18n.t('js.modules.buy_button.multi_option.discount_percentage', {
          rawDiscountPercentage: percent
        });
      }
    }
    return this.$discount.html(discountHtml != null ? discountHtml : discountHtml = "");
  },
  updateSoldMessage: function(arg) {
    var soldMessage, variationsSelected;
    variationsSelected = arg.variationsSelected, soldMessage = arg.soldMessage;
    if (variationsSelected) {
      return this.$soldMessage.text(soldMessage);
    }
  },
  updateBuyButton: function(option) {
    var buyUrl, localSupplyUrl, sale, variationsSelected;
    variationsSelected = option.variationsSelected, buyUrl = option.buyUrl, sale = option.sale;
    if (variationsSelected) {
      if (localSupplyUrl = this.getLocalSupplyUrl(option)) {
        buyUrl = localSupplyUrl;
      }
      this.$buyButton.attr("href", buyUrl);
      return this.$giftButton.attr("href", buyUrl);
    }
  },
  getLocalSupplyUrl: function(arg) {
    var buyUrl, ref, shippingOptionData;
    buyUrl = arg.buyUrl;
    if (!(shippingOptionData = typeof GoodsLocalSupply !== "undefined" && GoodsLocalSupply !== null ? (ref = GoodsLocalSupply.View) != null ? ref.getSelectedShippingOptionData() : void 0 : void 0)) {
      return;
    }
    return getBuyUrlWithShippingOptionData(buyUrl, shippingOptionData);
  },
  disableBuyButton: function() {
    this.hasBeenClicked = true;
    this.$buyButton.removeClass("state-buy");
    this.$buyButton.addClass("state-disabled");
    this.$headerOptions.fadeOut();
    return this.$buyButtonLoader.show();
  },
  enableBuyButton: function() {
    this.hasBeenClicked = false;
    this.$buyButton.removeClass("state-disabled");
    this.$buyButton.addClass("state-buy");
    this.$headerOptions.fadeIn();
    return this.$buyButtonLoader.hide();
  },
  processLink: function() {
    var newUrl;
    if (!this.buyButtonEnabled) {
      return;
    }
    if (!this.hasBeenClicked) {
      newUrl = this.$buyButton.attr("href");
      window.location = newUrl;
    }
    return this.disableBuyButton();
  },
  updateMultiOptionBreakoutButton: function(e) {
    var $option, deal, localSupplyUrl, option, optionInfo, ref, uuid, value;
    $option = this.$multiOptions.filter(e.currentTarget);
    if (!$option.length || $option.hasClass('selected') || !this.buyButtonEnabled) {
      return;
    }
    this.$multiOptions.removeClass('selected');
    $option.addClass('selected');
    value = $option.val();
    ref = $option.data(), deal = ref.deal, option = ref.option, uuid = ref.uuid;
    optionInfo = {
      buyUrl: value,
      dealUuid: deal,
      id: option,
      uuid: uuid
    };
    if (localSupplyUrl = this.getLocalSupplyUrl(optionInfo)) {
      value = localSupplyUrl;
    }
    this.$buyButton.attr('href', value);
    this.$giftButton.attr('href', value);
    if (this.$multiOptionOverlay.length) {
      this.updateClusterOptionPrice($option);
      this.syncDealOptions($option);
      this.cleanPriceBox();
      this.setOfferLabel($option.attr('data-offer-label'));
      this.fixPossiblePriceOverflow();
      this.updateClusterShippingCharge($option.attr('data-shipping-value'));
    } else {
      this.updateHeaderPrice($option);
      this.updateShippingCharge($option.attr('data-shipping-value'));
    }
    this.updateHeaderTitle($option);
    if ($option.parent('a').length) {
      BuyButton.eventBus.go('buy_button_clicked', e);
    }
    if (payload.goodsWarranty) {
      return window.DealEventPipe.trigger('goodsWarrantyUpdate', optionInfo);
    }
  },
  updateHeaderPrice: function($option) {
    var formattedPrice, formattedValue;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    this.$priceBox.text(formattedPrice);
    return this.$smallPrice.text(formattedValue);
  },
  updateHeaderTitle: function($option) {
    var breakoutOptionID, selectedTitle, targetTitleId;
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    this.$headerTitles.removeClass('checked');
    targetTitleId = "#header-title-" + breakoutOptionID;
    selectedTitle = this.$headerTitles.filter(targetTitleId);
    return selectedTitle.addClass('checked');
  },
  updateClusterOptionPrice: function($option) {
    var breakoutOptionID, finePrintDesc, formattedPrice, formattedValue, offerLabel, soldMessage;
    formattedPrice = $option.attr('data-formatted-price') || '';
    formattedValue = formattedPrice === $option.attr('data-formatted-value') ? '' : $option.attr('data-formatted-value');
    offerLabel = $option.attr('data-offer-label') || '';
    soldMessage = $option.attr('data-sold-message') || '';
    breakoutOptionID = this.getPurchaseClusterOptionId($option.attr('id'));
    finePrintDesc = $option.attr('data-description') || '';
    this.$priceBox.text(formattedPrice);
    this.$smallPrice.text(formattedValue);
    this.$valueBox.text(formattedValue);
    this.$soldBox.text(soldMessage);
    this.fixPossiblePriceOverflow();
    this.updateClusterOptionDiscount($option);
    this.updateExpiration($option);
    this.$priceBox.find('.urgency-pricing-label').text(offerLabel);
    this.updateUrgencyPricingMetaData(offerLabel, breakoutOptionID);
    if (soldMessage.length) {
      this.$qtyBought.text(soldMessage);
      this.$dealStatus.show();
    } else {
      this.$dealStatus.hide();
    }
    return this.updateFinePrint(finePrintDesc);
  },
  updateExpiration: function($option) {
    var expiration;
    expiration = $option.attr('data-expiration') || '';
    return this.$expirationBox.text(expiration);
  },
  updateClusterOptionDiscount: function($option) {
    var discountPercentage, savings;
    discountPercentage = $option.attr('data-discount-percentage') || '';
    savings = $option.attr('data-savings') || '';
    if (discountPercentage) {
      this.$discountPercent.text(discountPercentage);
      this.$discountYouSave.text(savings);
      $('.deal-discount').show();
    } else {
      $('.deal-discount').hide();
    }
    return this.$discountBox.text(discountPercentage);
  },
  updateUrgencyPricingMetaData: function(offerLabel, breakoutOptionID) {
    if (offerLabel) {
      return this.$dealHeroPrice.addClass('urgency-pricing tooltip-trigger').attr('data-bhw', 'UrgencyPrice').attr('data-tooltip-id', "urgency-pricing-tooltip-" + breakoutOptionID).attr('data-position', "left");
    } else {
      this.$dealHeroPrice.addClass('c-txt-price');
      return this.$dealHeroPrice.removeClass('urgency-pricing tooltip-trigger').removeAttr('data-bhw').removeAttr('data-tooltip-id').removeAttr('data-position');
    }
  },
  fixPossiblePriceOverflow: function() {
    this.$priceBox.removeClass('two-rows');
    this.$smallPrice.removeClass('two-rows');
    if (this.shouldShowPriceInTwoRows()) {
      this.$priceBox.addClass('two-rows');
      return this.$smallPrice.addClass('two-rows');
    }
  },
  viewAllOptions: function(e) {
    var ref;
    e.preventDefault();
    BuyButton.eventBus.go('view_options_clicked', e);
    if (((ref = this.$overlayList[0]) != null ? ref.scrollHeight : void 0) <= SCROLL_THRESHOLD) {
      return this.$overlayFade.hide();
    }
  },
  restoreOptionSelection: function() {
    return this.$el.find('.multi-option-breakout li input:first').trigger('click');
  },
  syncDealOptions: function($option) {
    var breakoutOptionId, optionId;
    optionId = $option.attr('id');
    if (optionId.indexOf('overlay') !== -1) {
      breakoutOptionId = "#" + (this.getPurchaseClusterOptionId(optionId));
      this.reorderDealOptions(breakoutOptionId);
    } else {
      breakoutOptionId = "#overlay-" + optionId;
    }
    return $(breakoutOptionId).prop('checked', true);
  },
  getPurchaseClusterOptionId: function(optionId) {
    if (optionId == null) {
      return '';
    }
    return optionId.replace('overlay-', '');
  },
  reorderDealOptions: function(breakoutOptionId) {
    var $optionElem;
    $optionElem = $(breakoutOptionId).parents('li');
    if ($optionElem.is(':visible')) {
      return;
    }
    $optionElem.insertBefore($optionElem.siblings('li').first());
    $optionElem.parent().find('li:visible:last').hide();
    return $optionElem.show();
  },
  updateFinePrint: function(finePrintDesc) {
    var $body, finePrintLines, tempLines;
    if (!(finePrintDesc != null ? finePrintDesc.length : void 0)) {
      return;
    }
    $body = $(document.body);
    if ($body.hasClass('getaways') || $body.hasClass('getaways-booking')) {
      finePrintLines = (typeof I18n !== "undefined" && I18n !== null ? I18n.country : void 0) === "US" ? (tempLines = _.filter(finePrintDesc.split(". "), function(line) {
        return line.replace(/<[^>]*>/g, '').trim().length > 0;
      }), tempLines = _.map(tempLines, function(line) {
        return "<li class='fine-print-description'>" + line + "</li>";
      }), tempLines.join('')) : "<span class='fine-print-description'>" + (finePrintDesc.replace(/\n/g, '<br/>')) + "</span>";
      $(finePrintLines).insertBefore(this.$finePrintDesc.first());
      this.$finePrintDesc.remove();
      return this.$finePrintDesc = $('.fine-print-description');
    } else {
      return this.$finePrintDesc.html(finePrintDesc);
    }
  },
  goToTips: function(e) {
    e.preventDefault();
    GIG.Modal.close();
    return window.location.href = "#tips";
  }
});

module.exports = BuyButton.View;


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

var Gift;

Gift = __webpack_require__(217);

if (window.MultiOptionModal == null) {
  window.MultiOptionModal = {};
}

MultiOptionModal.init = function(payload, done) {
  var openMultiOptionModal;
  if (!(payload != null ? payload.buyButton.multiOptionEnabled : void 0)) {
    return done();
  }
  openMultiOptionModal = function(e) {
    var $modal, $tooltipTrigger, firstAvailableOption;
    $modal = $('#options');
    if (!$modal.length) {
      return;
    }
    if ($modal.hasClass('tooltip')) {
      $tooltipTrigger = (e != null ? e.delegateTarget : void 0) ? $(e.delegateTarget) : Gift.cookieCreated ? $('.gift-button') : $('.buy-button');
      $tooltipTrigger.attr({
        'data-position': 'bottom',
        'data-tooltip-id': 'options',
        'data-trigger-event': 'js-trigger'
      });
      $tooltipTrigger.find('.tooltip-target').attr('data-position', 'bottom');
      GIG.Tooltip.helpers.tooltip.apply($tooltipTrigger[0], [
        {
          preventDefault: function() {}
        }
      ]);
    } else {
      if ($modal.hasClass('show-modal')) {
        return;
      }
      if ($(".header-row-sticky").is(":visible") && !payload.buyButton.multiOptionInline) {
        return;
      }
      if (!BuyButton.view.$multiOptions.filter('.selected').length) {
        firstAvailableOption = BuyButton.view.$multiOptions.not(":disabled")[0];
        BuyButton.view.updateMultiOptionBreakoutButton({
          currentTarget: firstAvailableOption
        });
      }
      GIG.Modal.open({
        el: $modal
      });
    }
    return {
      stopTheBus: true
    };
  };
  if (payload.buyButton.multiOptionInline) {
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998);
  }
  return $(function() {
    var $tooltipCloser, $triggers;
    $triggers = $(".show-multi-option-modal");
    $triggers.click(openMultiOptionModal);
    $tooltipCloser = $('.tooltip-close.icon-x');
    if ($tooltipCloser.length > 0) {
      $tooltipCloser.off('click');
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip);
    }
    GIG.Modal.onClose(Gift.removeCookie, 'options');
    $('#options').on('click', '.tooltip-close', Gift.removeCookie);
    return done();
  });
};

module.exports = MultiOptionModal;


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

var ApplePay, ApplePayUI, getApplePayButton, getConfirmationUrl, getLegalDisclaimerText, getTotalAmount, renderApplePayFeature, updatePromoCode, updatePromoCodeHandler;

ApplePayUI = __webpack_require__(275);

getLegalDisclaimerText = __webpack_require__(218).getLegalDisclaimerText;

ApplePay = window.ApplePay = {};

getTotalAmount = function() {
  return $('.option input[name=option]:checked').next('label').find('.breakout-option-price').text();
};

renderApplePayFeature = function() {
  getApplePayButton().after('<div class="applepay-promo-code"><a href="#applepay">' + I18n.t('js.modules.applepay.enter_promo_code_or_gift_code') + '</a></div>').before("<span class='applepay-legal-disclaimer'>" + (getLegalDisclaimerText('desktop')) + "</span>").addClass('applepay-button').html('<span class="applepay-logo" data-bhw="ApplePayButton"></span>');
  return updatePromoCode();
};

getApplePayButton = function() {
  return $('.buy-button:not(:disabled)');
};

getConfirmationUrl = function() {
  return $('.option input[name=option]:checked').val();
};

updatePromoCodeHandler = function() {
  return $('.option input[name=option]').change(updatePromoCode);
};

updatePromoCode = function() {
  return $('.applepay-promo-code a').attr('href', getConfirmationUrl());
};

ApplePay.init = function(payload, done) {
  var ref;
  if (ApplePayUI.hasValidConfirmationLink((ref = $('a.buy-button:first')[0]) != null ? ref.href : void 0)) {
    ApplePayUI.start(payload, getTotalAmount, getApplePayButton, renderApplePayFeature, updatePromoCodeHandler, getConfirmationUrl, 'SpyglassDesktopDealsPage');
  }
  return done();
};

module.exports = ApplePay;


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

var A11yToolInitializer, FixA11y;

A11yToolInitializer = __webpack_require__(419);

FixA11y = window.FixA11y != null ? window.FixA11y : window.FixA11y = {};

FixA11y.init = function(payload, done) {
  var fixA11y;
  fixA11y = payload.fixA11y;
  if (fixA11y == null) {
    return done();
  }
  A11yToolInitializer(fixA11y);
  return done();
};

module.exports = FixA11y;


/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var A11yUtility = __webpack_require__(420);

module.exports = function (options) {
  var a11yTool = new A11yUtility(options);
  $(window).load(function () {
    setTimeout(function () {
      a11yTool.init();
    }, 500);
  });
  $(document).ajaxSuccess(function () {
    setTimeout(function () {
      a11yTool.init();
    }, 500);
  });
  return a11yTool;
};


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SCREEN_READER_CSS = '.sr-only{border: 0; clip: rect(0, 0, 0, 0); height: 1px; margin: -1px; overflow: hidden; padding: 0; position: absolute; width: 1px;}';

var A11yUtility = function (options) {
  if (options === undefined) {
    options = {};
  }
  var selectorScope = options.scope;
  if (selectorScope === undefined) {
    selectorScope = 'body';
  }
  this.$elements = $(selectorScope);

  this.loggingEnabled = !!options.logging;

  this.addStylesToHead();
  return this;
};

A11yUtility.prototype.addStylesToHead = function () {
  $('head').append('<style type="text/css">' + SCREEN_READER_CSS + '</style>');
};

A11yUtility.prototype.getContextualText = function ($target) {
  if ($target.length === 0) {
    return undefined;
  }

  // try to do an educated guess of the contextual text for the element
  try {
    return $.trim($target.attr('title')) ||
           $.trim($target.data('originalTitle')) ||
           $.trim($target.closest('a').attr('title')) ||
           $.trim($target.closest('a').text()) ||
           $.trim($target.prev().children().length ?
             $($target.prev().children()[0]).text() : $target.prev().text()) ||
           $.trim($target.next().children().length ?
             $($target.next().children()[0]).text() : $target.next().text()) ||
           $.trim($target.parent().prev().children().length ?
             $($target.parent().prev().children()[0]).text() : $target.parent().prev().text()) ||
           $.trim($target.parent().next().children().length ?
             $($target.parent().next().children()[0]).text() : $target.parent().next().text()) ||
           ($.trim($target.attr('class')) ? $.trim($target.attr('class')).replace(/\s/g, ', ').replace(/[-_]/g, ' ') : undefined) ||
           ($target.attr('src') ? $target.attr('src').replace(/.*\/|\..*$/g, '') : undefined) ||
           '';
  } catch (e) {
    console.error(e.message); // eslint-disable-line
    return undefined;
  }
};

A11yUtility.prototype.fixImages = function () {
  // images without alt attribute
  var self = this;
  this.$elements.find('img:not([alt])')
    .each(function () {
      // bad idea to use contextual text of the image as the alt text
      // better to fallback to empty alt instead
      var $this = $(this);
      $this.attr('alt', '');
      if (self.loggingEnabled) {
        console.warn("FIX-A11Y: Image is missing 'alt' attr: "); // eslint-disable-line
        console.warn($this); // eslint-disable-line
      }
    });
};

A11yUtility.prototype.fixLinks = function () {
  // empty links
  var self = this;
  this.$elements.find('a:not([aria-label])')
    .filter(function () { return $.trim($(this).text()) === ''; })
    .each(function () {
      var $this = $(this);
      var text = self.getContextualText($this) || $.trim($.trim($this.attr('href')) && $this.attr('href').replace(/[-_/:]/g, ' ').replace(/^https*/g, ''));
      // found context for the link
      if (text !== undefined && text.length) {
        var span = document.createElement('span');
        span.className = 'sr-only';
        span.innerText = text;
        this.appendChild(span);
      } else {
        // can't get contextual text for the link
        // try to get the contextual alt text for any images without alt attribute
        $this.find('img:not([alt]), img[alt=""]')
          .each(function () {
            $(this).attr('alt', self.getContextualText($(this)));
          });
      }
      if (self.loggingEnabled) {
        console.warn('FIX-A11Y: Link is missing explanatory text: '); // eslint-disable-line
        console.warn($this); // eslint-disable-line
      }
    });
};

A11yUtility.prototype.fixForms = function () {
  // form fields without labels
  var self = this;
  this.$elements.find('textarea, input, select')
    .filter(function () {
      var $this = $(this);
      var accessibilityAttrs = ['title', 'aria-label', 'aria-labelledby'];
      for (var i = 0; i < accessibilityAttrs.length; i += 1) {
        var attr = $this.attr(accessibilityAttrs[i]);
        if (attr !== undefined && attr.length > 0) {
          return false;
        }
      }
      return true;
    })
    .each(function () {
      var $this = $(this);
      var text = $.trim($this.attr('placeholder') || self.getContextualText($this));
      // found context for the form element
      if (text !== undefined && text.length) {
        $this.attr('title', text);

        if (self.loggingEnabled) {
          console.warn("FIX-A11Y: Form element is missing 'title' attr: "); // eslint-disable-line
          console.warn($this); // eslint-disable-line
        }
      }
    });
};

A11yUtility.prototype.init = function () {
  this.fixImages();
  this.fixLinks();
  this.fixForms();
};

module.exports = A11yUtility;


/***/ }),

/***/ 426:
/***/ (function(module, exports) {

var StickyHandler,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

StickyHandler = (function() {
  function StickyHandler(element, container, elementOffset) {
    this.element = element;
    this.container = container;
    this.elementOffset = elementOffset;
    this.attachEvents = bind(this.attachEvents, this);
    this.windowHasHorizontalScroll = bind(this.windowHasHorizontalScroll, this);
    this.isWindowSmallerThanElement = bind(this.isWindowSmallerThanElement, this);
    this.shouldBeFixed = bind(this.shouldBeFixed, this);
    this.shouldBeAbsolute = bind(this.shouldBeAbsolute, this);
    this.shouldBeRelative = bind(this.shouldBeRelative, this);
    this.isFixedPositionOverrideRequired = bind(this.isFixedPositionOverrideRequired, this);
    this.getFixedCss = bind(this.getFixedCss, this);
    this.getAbsoluteCss = bind(this.getAbsoluteCss, this);
    this.getRelativeCss = bind(this.getRelativeCss, this);
    this.getCss = bind(this.getCss, this);
    this.updateCss = bind(this.updateCss, this);
    this.updatePosition = bind(this.updatePosition, this);
    this.scroll = bind(this.scroll, this);
    this.resize = bind(this.resize, this);
    this.updateDimensions = bind(this.updateDimensions, this);
    if (this.element.length) {
      this.container = this.container || $('body');
      if (this.window == null) {
        this.window = $(window);
      }
      this.document = $(document);
      this.parent = this.element.parent();
      this.sibling = this.parent.next();
      this.firstTick = true;
      if (this.elementOffset == null) {
        this.elementOffset = 0;
      }
      this.lastCss = {};
      this.scrollTop = this.window.scrollTop();
      this.attachEvents();
      this.updatePosition();
    }
  }

  StickyHandler.prototype.updateDimensions = function() {
    this.windowHeight = this.window.height();
    this.elementHeight = this.element.height();
    this.elementWidth = this.element.outerWidth();
    this.parentPadding = this.parent.outerWidth() - this.elementWidth;
    this.offsetLeft = this.sibling.offset().left + this.sibling.outerWidth() + this.parentPadding - this.window.scrollLeft();
    this.containerBottomPosition = this.container.offset().top + this.container.height();
    this.scrollTop = this.window.scrollTop();
    this.elementTop = this.parent.offset().top - this.elementOffset;
    return this.elementBottomPosition = this.scrollTop + this.elementHeight;
  };

  StickyHandler.prototype.resize = function() {
    this.firstTick = true;
    return this.updatePosition();
  };

  StickyHandler.prototype.scroll = function() {
    this.firstTick = false;
    return this.updatePosition();
  };

  StickyHandler.prototype.updatePosition = function() {
    this.updateDimensions();
    this.css = this.getCss();
    if (!_.isEqual(this.css, this.lastCss)) {
      this.updateCss();
      return this.lastCss = _.clone(this.css);
    }
  };

  StickyHandler.prototype.updateCss = function() {
    return this.element.css(this.css);
  };

  StickyHandler.prototype.getCss = function() {
    if (this.isWindowSmallerThanElement() || this.shouldBeRelative() || this.isFixedPositionOverrideRequired()) {
      return this.getRelativeCss();
    } else if (this.shouldBeAbsolute()) {
      return this.getAbsoluteCss();
    } else {
      return this.getFixedCss();
    }
  };

  StickyHandler.prototype.getRelativeCss = function() {
    return {
      'position': 'relative',
      'top': (this.isFixedPositionOverrideRequired() && !this.isWindowSmallerThanElement()) ? this.scrollTop - this.elementTop : 0,
      'width': '',
      'left': '',
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.getAbsoluteCss = function() {
    return {
      'position': 'absolute',
      'top': this.containerBottomPosition - this.elementHeight - this.elementTop,
      'width': this.elementWidth,
      'left': this.parentPadding,
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.getFixedCss = function() {
    return {
      'position': 'fixed',
      'top': this.elementOffset,
      'width': this.elementWidth,
      'left': this.offsetLeft,
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.isFixedPositionOverrideRequired = function() {
    return this.shouldBeFixed() && (this.firstTick || this.windowHasHorizontalScroll());
  };

  StickyHandler.prototype.shouldBeRelative = function() {
    return this.scrollTop <= this.elementTop;
  };

  StickyHandler.prototype.shouldBeAbsolute = function() {
    return this.elementBottomPosition > this.containerBottomPosition;
  };

  StickyHandler.prototype.shouldBeFixed = function() {
    return !(this.shouldBeRelative() || this.shouldBeAbsolute());
  };

  StickyHandler.prototype.isWindowSmallerThanElement = function() {
    return this.windowHeight < this.elementHeight;
  };

  StickyHandler.prototype.windowHasHorizontalScroll = function() {
    return this.window.scrollLeft() !== 0;
  };

  StickyHandler.prototype.attachEvents = function() {
    if (window.addEventListener) {
      window.addEventListener('scroll', this.scroll, false);
      window.addEventListener('resize', this.resize, false);
    } else if (window.attachEvent) {
      window.attachEvent('onscroll', this.scroll);
      window.attachEvent('onresize', this.resize);
    }
    return $(document.body).on('modal-open', this.scroll);
  };

  return StickyHandler;

})();

module.exports = StickyHandler;


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var generateCartUrl;

generateCartUrl = function(optionuuid, dealuuid) {
  return "/cart/add/" + optionuuid + "?deal_id=" + dealuuid;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.Cart == null) {
    window.Cart = {};
  }
  if (Cart.Helpers == null) {
    Cart.Helpers = {};
  }
  Cart.Helpers.generateCartUrl = generateCartUrl;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    generateCartUrl: generateCartUrl
  };
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module)))

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

var each, extend, find, getBuyUrlWithShippingOptionData, getRedemptionLocationsFromResponse, map, mergeRedemptionLocationInfo, omit, ref;

ref = __webpack_require__(1), each = ref.each, extend = ref.extend, find = ref.find, map = ref.map, omit = ref.omit;

mergeRedemptionLocationInfo = function(optionIdMap, redemptionLocationMap) {
  var id, optionWithRedemptionLocation, shippingOption;
  if (!optionIdMap) {
    return {};
  }
  for (id in optionIdMap) {
    shippingOption = optionIdMap[id];
    optionWithRedemptionLocation = find(shippingOption, function(option) {
      var ref1;
      return (ref1 = option.redemptionLocations) != null ? ref1.length : void 0;
    });
    each(optionWithRedemptionLocation != null ? optionWithRedemptionLocation.redemptionLocations : void 0, function(location) {
      return extend(location, omit(redemptionLocationMap[location.id], 'id', 'uuid'));
    });
  }
  return optionIdMap;
};

getBuyUrlWithShippingOptionData = function(buyUrl, shippingOptionData) {
  var key, params, value;
  params = [];
  for (key in shippingOptionData) {
    value = shippingOptionData[key];
    if (value) {
      params.push(key + "=" + value);
    }
  }
  return "" + buyUrl + (buyUrl.indexOf('?') > -1 ? '&' : '?') + (params.join('&'));
};

getRedemptionLocationsFromResponse = function(response, variantId) {
  var optionIdMap, optionWithRedemptionLocation, redemptionLocationMap, ref1, shippingOptions;
  if (response == null) {
    response = {};
  }
  optionIdMap = response.optionIdMap, redemptionLocationMap = response.redemptionLocationMap;
  if (!(optionIdMap && redemptionLocationMap)) {
    return [];
  }
  shippingOptions = optionIdMap[variantId];
  optionWithRedemptionLocation = find(shippingOptions, function(option) {
    var ref1;
    return (ref1 = option.redemptionLocations) != null ? ref1.length : void 0;
  });
  if (!(optionWithRedemptionLocation != null ? (ref1 = optionWithRedemptionLocation.redemptionLocations) != null ? ref1.length : void 0 : void 0)) {
    return [];
  }
  return map(optionWithRedemptionLocation.redemptionLocations, function(location) {
    return extend({}, location, omit(redemptionLocationMap[location.id], 'id', 'uuid'));
  });
};

module.exports = {
  mergeRedemptionLocationInfo: mergeRedemptionLocationInfo,
  getBuyUrlWithShippingOptionData: getBuyUrlWithShippingOptionData,
  getRedemptionLocationsFromResponse: getRedemptionLocationsFromResponse
};


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98), __webpack_require__(42)))

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })

/******/ });


// WEBPACK FOOTER //
// base-531e0ae1fb.js